import React, { useEffect, useState, useMemo, useRef } from "react";
import { Badge } from "react-bootstrap";
import moment from "moment";
// import { AiOutlineCheck } from "react-icons/ai";
// import { GrFormClose } from "react-icons/gr";
// import { AiOutlineClose } from "react-icons/ai";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
// import ReactDOM from "react-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import FilterModal from "../../../components/Modal/FilterModal";
import Select from "react-select";
import ReceivingCard from "../../../components/ReceivingCard/ReceivingCard";
import SuspendedConfirmation from "../../../components/Modal/SuspendedConfirmation";
import CancelConfirmation from "../../../components/Modal/CancelConfirmation";
// import LookupReceiptModal from "../../../components/Modal/LookupReceiptModal";
import StoreAccountPaymentModal from "../../../components/Modal/StoreAccountPaymentModal";
import CompleteSaleModal from "../../../components/Modal/CompleteSalemodal";
import FileInput from "../../../components/FormControls/FileInput";
import { toastError, toastSuccess } from "../../../common/Toast";
import ItemsDetailsModal from "../../../components/Modal/ItemsDetailsModal";
import { Closed, Expense } from "../../../common/imagePath";
import { uploadAWS } from "../../../common/AWSHelper";
import {
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_RECEIVING,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
// import { TemporaryCredentials } from "aws-sdk";

let counter = 0;
const ManageReceiving = () => {
  let navigate = useNavigate();

  // const [excelData, setExcelData] = useState(true);
  // const location = useLocation();
  //   console.log(location.state, "location.state 589");
  //  if(location.state.length > 0){
  //   setExcelData(location.state)
  //  }

  let originalPass = [];
  let matchedTagOptions;
  const paramObject = useParams();

  let totalRef = useRef(0);
  const Location = localStorage.getItem("Location");
  const Clone = localStorage.getItem("Clone")
    ? localStorage.getItem("Clone")
    : 0;
  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");
  // const [selectedterms, setSelectedTerms] = useState("");
  const [loading, setLoading] = useState(false);
  const [ImageUrl, setImageUrl] = useState("");
  const [customFileUrl, setCustomFileUrl] = useState("");
  // const [validationErrors, setValidationErrors] = useState([]);
  const [changeImagename, setChangeImagename] = useState(false);
  const [commonDiscount, setCommonDiscount] = useState(0);
  // const [customership, setCustomerShip] = useState(0);
  // const [counter, setCounter] = useState(0); // initialize counter
  const [formValues, setFormValues] = useState({});
  const [btnLoader, setBtnLoader] = useState({ SelectImage: false });
  const [selectedsupplier, setSelectedSupplier] = useState("");
  const [supoptions, setSupOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [supplierName, setSupplierName] = useState();
  const [statenew, setStateNew] = useState([]);
  const [categoryStatenew, setCategoryStateNew] = useState([]);
  const [isContentVisible, setIsContentVisible] = useState(true);
  const [entireReceivingDiscount, setEntireReceivingDiscount] = useState(0);
  const [discountInputValue, setDiscountInputValue] = useState(0);
  const [amountToSubtract, setAmountToSubtract] = useState(0);
  const [method, setMethod] = useState(["Cash"]); // Setting the payment Method.
  const [dueAmount, setDueAmount] = useState(0); // to keep track of all the DueAmount made
  const [payments, setPayments] = useState([]); // to keep track of all the payments made
  const [deletedPaymentIndex, setDeletedPaymentIndex] = useState(-1);
  // const [showDateInput, setShowDateInput] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState({
    id: 1,
    name: "Cash",
  });
  // const [categoryAmount, setCategoryAmount] = useState("");
  const [itemsDetailsData, setItemsDetailsData] = useState();
  const [isTransfer, setIsTransfer] = useState("");
  const [select, setSelect] = useState("Receive");
  const [isStoreAccountPayment, setIsStoreAccountPayment] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [customFieldReceivingValues, setCustomFieldReceivingValues] = useState(
    []
  );
  // const [paymentValues, setPaymentValues] = useState([]);
  const [selectedCustomField, setSelectedCustomField] = useState("");
  const [selectCustomCheckBox, setSelectCustomCheckBox] = useState(false);
  const [selectedCustomImage, setSelectedCustomImage] = useState("");
  const [selectedCustomFile, setSelectedCustomFile] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [discountComment, setDiscountComment] = useState("");
  const [comment, setComment] = useState("");
  const [couponCode, setCouponCode] = useState("");
  // const [Suspend, setSuspend] = useState("");
  const [paymentCurrency, setPaymentCurrency] = useState("USD");
  const [receivingTypeDropdown, setReceivingTypeDropdown] = useState([]);
  const [paymentTypeDropdown, setPaymentTypeDropdown] = useState([]);
  const [receivingTypeId, setReceivingTypeId] = useState(1);
  const [selectedReceiveOption, setSelectedReceiveOption] =
    useState("Purchase Order");
  const [isPo, setIsPo] = useState(1);
  const [isStoreAccountPaymentFlag, setIsStoreAccountPaymentFlag] = useState(0);
  const [supplierId, setSupplierId] = useState("");
  const [paidAmount, setPaidAmount] = useState("");

  const [locationdropdown, setLocationDropdown] = useState([]);
  const [chartOfAccountDropdown, setChartOfAccountDropdown] = useState([]);
  const [customersDropdown, setCustomersDropdown] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  //const [shippingAddress, setShippingAddress] = useState("");

  const [termsDropdown, setTermsDropdown] = useState([]);
  const [tagsDropdown, setTagsDropdown] = useState([]);
  const [showTranser, setShowTranser] = useState();

  // const [selectedLocation, setSelectedLocation] = useState({ label: "", value: "", });
  // const [selectedTransferToLocation, setSelectedTransferToLocation] = useState({ label: "", value: "", });
  const [selectedLocation, setSelectedLocation] = useState();
  const [selectedTransferToLocation, setSelectedTransferToLocation] =
    useState();

  const [refrenceno, setRefrenceno] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [termsId, setTermsId] = useState("");

  //const [tags, setTags] = useState([]);
  const [selectedtags, setSelectedtags] = useState(""); //store seletcd tags

  const [accountId, setAccountId] = useState("");
  const [shipToCustomer, setShipToCustomer] = useState("");
  const [shippingAddressText, setshippingAddressText] = useState("");

  // const [supplierEmail, setSupplierEmail] = useState("");

  const [shipVia, setShipVia] = useState("");
  const [changeFileName, setChangeFileName] = useState(false);
  const [FileUrl, setFileUrl] = useState("");
  const [btnFileLoader, setBtnFileLoader] = useState({ Receipt: false });
  // const [isExpense, setIsExpense] = useState(false);
  // const [isBill, setIsBill] = useState(false);
  // const [isCheck, setIsCheck] = useState(false);
  // const [isVendorCredit, setIsVendorCredit] = useState(false);
  const [selectedReceiveDropdown, setSelectedReceiveDropdown] = useState();
  const [balanceAmount, setBalanceAmount] = useState();

  const [emailsuppliers, setEmailsuppliers] = useState("");
  const [mailingAddress, setMailingAddress] = useState("");
  const [balancesuppliers, setBalanceSuppliers] = useState("");

  const [addresssuppliers, setAddresssuppliers] = useState();

  const [todayDate, setTodayDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedCategoryForSearch, setSelectedCategoryForSearch] =
    useState(null);
  const [receivingDate, setReceivingDate] = useState(todayDate);
  // const [balanceAmount, setBalanceAmount] = useState();
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [toggleItemsFilterSection, setToggleItemsFilterSection] =
    useState(false);
  const [isReadOnly, setIsReadOnly] = useState(true);

  // show Shipping Address editable
  const [shippingEditAddrerss, setShippingEditAddrerss] = useState(false);

  //show internal details
  const [showRowInternalDetails, setShowRowInternalDetails] = useState(true);

  //accordian

  const [isAccordionOpen, setAccordionOpen] = useState(false);
  const toggleAccordion = () => {
    setAccordionOpen(!isAccordionOpen);
  };
  const [runApi, setRunApi] = useState(false);
  const [restirctedit, setRestrictEdit] = useState(0);

  //validation for transfer

  const [transferFromLocation, setTransferFromLocation] = useState(false);
  const [transferToLocation, setTransferToLocation] = useState(false);

  //////

  //LocalStorage
  // const[localValues,setLocalValues] = useState();
  const [localValues, setLocalValues] = useState({});

  const addDaysToDate = (date, days) => {
    const currentDate = new Date(date);
    const dueDate = new Date(currentDate.setDate(currentDate.getDate() + days));
    return dueDate.toISOString().split("T")[0];
  };

  const today = moment();

  // const handleForCategorySearch = (event) => {
  //   console.log("selectedOptionselectedOption", event.value);
  //   setSelectedCategoryForSearch(event.value)
  // }
  const handleForCategorySearch = (event) => {
    if (event && event.value !== null) {
      setSelectedCategoryForSearch(event.value);
    } else {
      setSelectedCategoryForSearch(""); // or null, depending on your needs
    }
  };

  //Styles
  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      color: "#000",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      color: state.isActive ? "#000" : "#000",
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        color: "#000",
        backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
      },
    }),
  };

  //For LocalStorage

  let LStotalAmt = JSON.parse(localStorage.getItem("receivingDraft"));
  LStotalAmt = LStotalAmt?.inputDropdown?.reduce((acc, cur) => {
    if (cur.Module == "Item") {
      acc += +cur.Total;
    }
    return acc;
  }, 0);

  let amountForVendor = JSON.parse(localStorage.getItem("receivingDraft"));
  amountForVendor = amountForVendor?.expenseDropdown?.reduce((acc, cur) => {
    if (cur.Module == "Accounts") {
      acc += +cur.Total;
    }
    return acc;
  }, 0);

  let LSItemtotalQty = JSON.parse(localStorage.getItem("receivingDraft"));
  LSItemtotalQty = LSItemtotalQty?.inputDropdown?.reduce((acc, cur) => {
    if (cur.Module == "Item") {
      acc += +cur.itemquantity;
    }
    return acc;
  }, 0);

  // Function to handle search input change
  const handleSearchInputChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);

    // Filter the data based on the search value
    const filteredItems = statenew.filter(
      (item) =>
        item.ItemName?.toLowerCase().includes(value?.toLowerCase()) ||
        item.VariationName?.toLowerCase().includes(value?.toLowerCase())
    );
    setFilteredData(filteredItems);
  };
  const [checkboxes, setCheckboxes] = useState(0);

  const vaidation = (name, value) => {
    switch (name) {
      case "Receipt":
        if (!value.name.match(/\.(jpg|jpeg|png|pdf)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };
  const uploadFilePDF = async (file, type, index) => {
    setBtnFileLoader({ [type]: true });

    setLoading(true);
    await uploadAWS(file, AWS_IMAGE_FOLDER_RECEIVING, (data) => {
      if (data) {
        if (type === "Receipt") {
          if (paramObject.id == undefined) {
            const x = { ...localValues, Attachment: data };
            setLocalValues(x);
            localStorage.setItem("receivingDraft", JSON.stringify(x));
          }
          setFileUrl(data);
          setLoading(false);
        }
      }
    });
  };

  function handleChange(event) {
    setFormValues({
      ...formValues,
      [event.target.name]: event.target.value,
    });
  }

  const handleFileChange = (event, index) => {
    setChangeFileName(true);
    if (vaidation(event.target.name, event?.currentTarget?.files[0])) {
      uploadFilePDF(event?.currentTarget?.files[0], event.target.name, index);
    }
    const files = event.target.files;
    if (files) {
      let images = [];
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          images.push({
            name: files[i].name,
            preview: e.target.result,
          });
          // setPreviewImage(images);
        };
        reader.readAsDataURL(files[i]);
      }
    }
  };
  //show details row true false
  const handleShowDetails = (e) => {
    showRowInternalDetails
      ? setShowRowInternalDetails(false)
      : setShowRowInternalDetails(true);
  };

  const handleChangeAccountSalesData = (event, fieldName) => {
    let x;

    if (fieldName === "ShippingAddress") {
      x = { ...localValues, [fieldName]: event?.target?.value };
      setshippingAddressText(event);
    }
    if (fieldName === "referenceno") {
      x = { ...localValues, [fieldName]: event?.target?.value };
      setRefrenceno(event.target.value);
    } else if (fieldName === "DueDate") {
      x = { ...localValues, [fieldName]: event?.target?.value };

      setDueDate(event.target.value);
    } else if (fieldName === "TermsID") {
      const selectedTerm = termsDropdown.find(
        (term) => term.ID === event.value
      );
      const newDueDate = addDaysToDate(todayDate, selectedTerm.Value);
      x = {
        ...localValues,
        [fieldName]: event?.value,
        ["DueDate"]: newDueDate,
      };
      // setSelectedTerm(selectedTerm);
      setTermsId(event.value);
      if (selectedTerm) {
        // const newDueDate = addDaysToDate(todayDate, selectedTerm.Value);
        handleChangeAccountSalesData(
          { target: { value: newDueDate } },
          "DueDate"
        );
      }
    }
    // else if (fieldName === "TermsID") {
    //   setTermsId(event.value);
    // }
    else if (fieldName === "Tags") {
      x = { ...localValues, [fieldName]: event.map((x) => x.value) };

      setSelectedtags(Array.isArray(event) ? event.map((x) => x.value) : []);
    } else if (fieldName === "AccountId") {
      x = { ...localValues, [fieldName]: event?.value };
      setAccountId(event?.value);
    } else if (fieldName === "ShipToCustomer") {
      x = { ...localValues, [fieldName]: event?.value };
      setShipToCustomer(event.value);
    } else if (fieldName === "ShippingAddress") {
      x = { ...localValues, [fieldName]: event };
      setshippingAddressText(event);
    } else if (fieldName === "receivingDate") {
      x = { ...localValues, [fieldName]: event?.target?.value };
      setReceivingDate(event.target.value);
    } else if (fieldName === "Email") {
      x = { ...localValues, [fieldName]: event?.target?.value };
      setEmailsuppliers(event.target.value);
    } else if (fieldName === "MailingAddress") {
      x = { ...localValues, [fieldName]: event?.target?.value };

      setAddresssuppliers(event.target.value);
    } else if (fieldName === "ShipVia") {
      x = { ...localValues, [fieldName]: event?.target?.value };
      setShipVia(event.target.value);
    }
    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
  };

  const handleTotalChange = (index, value) => {
    updatedData = [...statenew];

    let totalvalue = value;
    let itemquantity = updatedData[index].itemquantity;
    let itemdiscount = updatedData[index].itemdiscount;
    if (itemdiscount == undefined || itemdiscount == "") {
      itemdiscount = 0;
    }

    // Calculate the subtotal after applying the discount
    let subtotal = totalvalue / (1 - itemdiscount / 100);

    // Calculate the price per quantity
    let price = subtotal / itemquantity;

    updatedData[index] = { ...updatedData[index], Total: value };
    updatedData[index] = { ...updatedData[index], CostPrice: price };

    setStateNew(updatedData);
    updateTotal(updatedData);
  };

  const paymentTypeMap = {};
  paymentTypeDropdown.forEach((paymentType) => {
    paymentTypeMap[paymentType.ID] = paymentType.Paymenttypename;
  });

  // location dropdown Binding.
  let locationDropdownOption = [];
  const locationDropdown = locationdropdown.map((u, i) => {
    locationDropdownOption[i] = { label: u.Name, value: u.Id };
  });

  const handleTransferRequest = () => {
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/transferandincomingrequest?locationid=${Location}&status=TRANSFER`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log("response.data.ResponseData[0]", response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleTransferToRequest = () => {
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/transferandincomingrequest?locationid=${Location}&status=INCOMING`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log("response.data.ResponseData[0]", response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // handle Change for the location.
  const handleTransferToLocationChange = (e) => {
    const x = { ...localValues, transferLocationChange: e.value };
    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
    setTransferToLocation(true);
    setSelectedTransferToLocation(e.value);
  };

  // handle Change for the location.
  const handleLocationChange = (e) => {
    const x = { ...localValues, locationWarehouseDropdown: e.value };
    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
    setTransferFromLocation(true);
    // console.log("selectedOption ==>", e.value);
    setSelectedLocation(e.value);
  };

  const handlePayment = (method, id, name) => {
    setMethod(method);
    setSelectedPayment({ id, name });
  };

  //  For Dynamic Dropdown Receive Type
  const handleOptionSelect = (e, label, value) => {
    if (restirctedit == 1 && paramObject.id > 0) {
      setModal(true);
      return;
    }
    let x;
    //SettingUp Data in Local Storage
    if (paramObject.id === undefined) {
      if (value == 5 || value == 6 || value == 7) {
        x = {
          ...localValues,
          inputDropdown: [],
          CommonDiscountLS: "",
          DiscountChange: 0,
          Comments: "",
          receivingDropdown: [value, label],
        };
        setStateNew([]);
        setCommonDiscount(0);
        setDiscountComment();
        setEntireReceivingDiscount(0);
      } else {
        x = {
          ...localValues,
          expenseDropdown: [],
          receivingDropdown: [value, label],
        };
        setCategoryStateNew([]);
      }

      setLocalValues(x);
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }

    setStateNew([]);
    updateTotal([]);
    setEntireReceivingDiscount("");
    setSelectedPayment([]);
    setPayments([]);
    // setSelectedOption(null);
    setDueAmount(0);
    // handleSuspend([])
    setCategoryStateNew([]);
    // setShipVia("");
    // setAddresssuppliers();
    // setEmailsuppliers("");
    setBalanceSuppliers("");
    // setReceivingDate("");
    // setshippingAddressText("");
    setShipToCustomer("");
    setAccountId("");
    // setSelectedtags("");
    setTermsId("");
    setDueDate("");
    // setRefrenceno("");
    setCommonDiscount("");

    setSelectedReceiveDropdown(value);

    let eve = e.target;
    const dataItemId = eve.getAttribute("value");
    const receiveType = dataItemId;
    setReceivingTypeId(value);
    setSelect(label);
    setIsTransfer(label === "Transfer");
    setIsStoreAccountPayment(label === "Supplier Account");
    const selectedOption = receivingTypeDropdownOption.find(
      (option) => option.value == receiveType
    );

    let o = selectedOption.label;
    setSelectedReceiveOption(o);

    setIsPo(1);
    if (receiveType != 1) {
      setIsPo(0);
    }

    setIsStoreAccountPaymentFlag(0);
    if (receiveType === 6) {
      setIsStoreAccountPaymentFlag(1);
    }
  };

  const handleCancelPopup = (pID) => {
    setStateNew([]);
    updateTotal([]);
    setEntireReceivingDiscount("");
    setSelectedOption(null);
    // setDueAmount([])
    setDueAmount(0);

    // setPayments([]);
    // setComment([])
  };

  const handleSuspend = (event) => {
    if (selectedReceiveDropdown === 4) {
      if (!transferFromLocation) {
        toastError("Please select location");
        return;
      }
      if (!transferToLocation) {
        toastError("Please select location");
        return;
      }
    }
    let customFielddata = customFieldReceivingValues.filter(function (rowData) {
      return (
        rowData.CustomFieldLabelID !== null && rowData.CustomFieldValue !== null
      );
    });
    let Itemdata = statenew.filter(function (salesItem) {
      return salesItem.itemsid != "";
    });

    let p = payments;
    originalPass = p;

    let paymentMethodData = originalPass.filter(function (paymentData) {
      return paymentData.PaymentId != "";
    });

    // setLoading(true);
    // Create the payment object
    let paymentData = {};
    paymentData.paymentValueXML = paymentMethodData;
    let paymentvaluejsonstring = JSON.stringify(paymentData);

    const Itemobj = {};
    Itemobj.receivingitemsXML = Itemdata;
    let itemjsonstring = JSON.stringify(Itemobj);

    // For Custom Field Value
    let customValuesData = {};
    customValuesData.customValueXML = customFielddata;
    let customvaluejsonstring = JSON.stringify(customValuesData);

    // console.log("customFielddata123",customFielddata)

    // //customFields Map
    // const customfield = {}
    // let customField = customFieldReceivingValues.map((item) => {
    //   // if(formValuesDataToSend[item.fieldName]!==undefined){
    //   console.log(item.CustomFieldValue, item.CustomFieldLabelID, "gsadhgshef")
    //   customfield[item.CustomFieldLabel] = item.CustomFieldValue
    //   // }
    // })
    // let customfieldvaluejsonstring = JSON.stringify(customfield);

    // console.log(customfield,"customFieldaaaaaa")
    // console.log(customfieldvaluejsonstring,"customFieldaaaaaa")

    // Create the form data object
    const formValuesDataToSend = {
      xmlreceivingsitems: itemjsonstring,
      xmlcustomfieldvalue: customvaluejsonstring,
      xmlpaymentvalue: paymentvaluejsonstring,
      // xmlcustomfield: customfieldvaluejsonstring,
      loginuserid: Id,
      // total: totalRef.current,
      // total:
      //   selectedReceiveDropdown === 6
      //     ? parseFloat(paymentAmount)
      //     : (paramObject.id!==undefined)?(totalRef.current):(LStotalAmt),
      total:
        selectedReceiveDropdown === 6
          ? parseFloat(paymentAmount)
          : paramObject.id !== undefined
          ? totalRef.current
          : selectedReceiveDropdown === 5 || selectedReceiveDropdown === 7
          ? amountForVendor
          : LStotalAmt - commonDiscount,
      subtotal: paramObject.id !== undefined ? totalRef.current : LStotalAmt,
      comment: comment,
      id: paramObject.id || 0,
      supplierid: supplierId, // selectedOption.value,
      paymentcurreny: paymentCurrency,
      receivingtypeid: receivingTypeId,
      locationid: receivingTypeId == 4 ? selectedLocation : Location,
      // locationid: Location,
      // transfertolocationid: selectedTransferToLocation.value,
      transfertolocationid: selectedTransferToLocation,
      ispo: isPo,
      storeaccountpayment: isStoreAccountPaymentFlag,
      totalquantitypurchased: 0,
      totalquantityreceived: totalQuantity,
      discountcomment: discountComment,
      // discountentiresale: discountInputValue,
      discountentiresale: commonDiscount,
      addcouponcodes: couponCode,
      issuspended: 1,
      billno: refrenceno != "" && refrenceno != undefined ? refrenceno : 0,
      duedate: dueDate,
      termsid: termsId,
      receipt: FileUrl,
      tagids: selectedtags != undefined ? selectedtags.toString() : "",
      accountid: accountId,
      shiptocustomer: shipToCustomer,
      shippingadress: shippingAddressText,
      shipvia: shipVia,
      receivingdate: receivingDate,
      supplieremail: emailsuppliers,
      mailingaddress: mailingAddress,
      balance: balanceAmount,
      IsComplete: 1,
    };

    // return true;
    // Send the form data using axios
    axios
      .post(
        `${config.receivingBaseUrl}/receivings/upsert`,
        formValuesDataToSend,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode == "SUCCESS") {
          if (paramObject.id == undefined) {
            localStorage.removeItem("receivingDraft");
          }
          localStorage.removeItem("Clone");
          toastSuccess(SUCCESS_MESSAGE);
          // setShowModal(true);

          navigate(`/receiving`);

          setLoading(false);
          setStateNew([]);
          updateTotal([]);
          setEntireReceivingDiscount("");
          setSelectedPayment([]);
          setPayments([]);
          setSelectedOption(null);
          setDueAmount(0);
          // handleSuspend([])
          setCategoryStateNew([]);
          setShipVia("");
          setAddresssuppliers();
          setEmailsuppliers("");
          setBalanceSuppliers("");
          setReceivingDate("");
          setshippingAddressText("");
          setShipToCustomer("");
          setAccountId("");
          setSelectedtags("");
          setTermsId("");
          setDueDate("");
          setRefrenceno("");
          setCommonDiscount("");
          // setDueAmount([])

          // show the modal after form submission
          // window.location.reload();
        } else if (res.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleIsComplete = (event) => {
    if (!transferFromLocation) {
      toastError("Please select location");
      return;
    }
    if (!transferToLocation) {
      toastError("Please select location");
      return;
    }

    let customFielddata = customFieldReceivingValues.filter(function (rowData) {
      return (
        rowData.CustomFieldLabelID !== null && rowData.CustomFieldValue !== null
      );
    });
    let Itemdata = statenew.filter(function (salesItem) {
      return salesItem.itemsid != "";
    });

    let p = payments;
    originalPass = p;

    let paymentMethodData = originalPass.filter(function (paymentData) {
      return paymentData.PaymentId != "";
    });

    const Itemobj = {};

    // For Custom Field Value
    let customValuesData = {};
    customValuesData.customValueXML = customFielddata;
    let customvaluejsonstring = JSON.stringify(customValuesData);

    Itemobj.receivingitemsXML = Itemdata;
    let itemjsonstring = JSON.stringify(Itemobj);

    // setLoading(true);
    // Create the payment object
    let paymentData = {};
    paymentData.paymentValueXML = paymentMethodData;
    let paymentvaluejsonstring = JSON.stringify(paymentData);

    // Create the form data object
    const formValuesDataToSend = {
      xmlreceivingsitems: itemjsonstring,
      xmlcustomfieldvalue: customvaluejsonstring,
      xmlpaymentvalue: paymentvaluejsonstring,
      loginuserid: Id,

      // total: totalRef.current,
      total:
        selectedReceiveDropdown === 6
          ? parseFloat(paymentAmount)
          : paramObject.id !== undefined
          ? totalRef.current
          : LStotalAmt,
      // subtotal: totalRef.current,
      subtotal: paramObject.id !== undefined ? totalRef.current : LStotalAmt,
      comment: comment,
      // id: paramObject.id || 0,
      id: Clone ? 0 : paramObject.id ? paramObject.id : 0,
      supplierid: supplierId, // selectedOption.value,
      paymentcurreny: paymentCurrency,
      receivingtypeid: receivingTypeId,
      locationid: receivingTypeId == 4 ? selectedLocation : Location,
      // locationid: Location,
      // transfertolocationid: selectedTransferToLocation.value,
      transfertolocationid: selectedTransferToLocation,
      ispo: isPo,
      storeaccountpayment: isStoreAccountPaymentFlag,
      totalquantitypurchased: 0,
      totalquantityreceived: 0,
      discountcomment: discountComment,
      // discountentiresale: discountInputValue,
      discountentiresale: commonDiscount,
      addcouponcodes: couponCode,
      issuspended: 1,
      billno: refrenceno != "" && refrenceno != undefined ? refrenceno : 0,
      duedate: dueDate,
      termsid: termsId,
      receipt: FileUrl,
      tagids: selectedtags != undefined ? selectedtags.toString() : "",
      accountid: accountId,
      shiptocustomer: shipToCustomer,
      shippingadress: shippingAddressText,
      shipvia: shipVia,
      receivingdate: receivingDate,
      supplieremail: emailsuppliers,
      mailingaddress: addresssuppliers,
      balance: balanceAmount,
      IsComplete: 0,
    };

    // return true;
    // Send the form data using axios
    axios
      .post(
        `${config.receivingBaseUrl}/receivings/upsert`,
        formValuesDataToSend,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode == "SUCCESS") {
          localStorage.removeItem("Clone");
          localStorage.removeItem("receivingDraft");
          toastSuccess(SUCCESS_MESSAGE);
          setShowModal(true);
          navigate(`/receiving`);
          setLoading(false);

          // setStateNew([]);
          // updateTotal([]);
          // setEntireReceivingDiscount([]);
          // setSelectedPayment([]);
          // setPayments([]);
          // setSelectedOption(null);
          // setDueAmount(0);
          // // handleSuspend([])
          // setCategoryStateNew([]);
          // setShipVia("");
          // setAddresssuppliers();
          // setEmailsuppliers("");
          // setBalanceSuppliers("");
          // setReceivingDate("");
          // setshippingAddressText("");
          // setShipToCustomer("");
          // setAccountId("");
          // setSelectedtags("");
          // setTermsId("");
          // setDueDate("");
          // setRefrenceno("");
          // setCommonDiscount([]);
          // setDueAmount([])

          // show the modal after form submission
          // window.location.reload();
        } else if (res.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleDeletePayment = (index) => {
    setDeletedPaymentIndex(index);
    let prevDueAmount =
      parseFloat(dueAmount) + parseFloat(payments[index].PaymentAmount);
    setDueAmount(prevDueAmount);
    setPayments(payments.filter((payment, i) => i !== index)); // Remove the deleted payment from the payments array
    setDeletedPaymentIndex(-1); // Reset the deletedPaymentIndex state
  };

  const handleSubmit = (event) => {
    let customFielddata = customFieldReceivingValues.filter(function (rowData) {
      return (
        rowData.CustomFieldLabelID !== null && rowData.CustomFieldValue !== null
      );
    });

    let Itemdata = statenew.filter(function (salesItem) {
      return salesItem.itemsid != "";
    });

    let paymentMethodData = originalPass.filter(function (paymentData) {
      return paymentData.PaymentId != "";
    });

    const Itemobj = {};

    // For Custom Field Value
    let customValuesData = {};
    customValuesData.customValueXML = customFielddata;
    let customvaluejsonstring = JSON.stringify(customValuesData);

    Itemobj.receivingitemsXML = Itemdata;
    let itemjsonstring = JSON.stringify(Itemobj);

    // Create the payment object
    let paymentData = {};
    paymentData.paymentValueXML = paymentMethodData;
    let paymentvaluejsonstring = JSON.stringify(paymentData);

    // Create the form data object
    const formValuesDataToSend = {
      xmlreceivingsitems: itemjsonstring,
      xmlcustomfieldvalue: customvaluejsonstring,
      xmlpaymentvalue: paymentvaluejsonstring,
      loginuserid: Id,

      // total: totalRef.current,
      total:
        selectedReceiveDropdown === 6
          ? parseFloat(paymentAmount)
          : paramObject.id !== undefined
          ? totalRef.current
          : LStotalAmt,
      subtotal: paramObject.id !== undefined ? totalRef.current : LStotalAmt,
      comment: comment,
      id: Clone > 0 ? 0 : paramObject.id || 0,
      supplierid: supplierId, //selectedOption.value,
      paymentcurreny: paymentCurrency,
      receivingtypeid: receivingTypeId,
      //locationid: receivingTypeId == 6 ? Location : selectedLocation,
      locationid: Location,
      // transfertolocationid: selectedTransferToLocation.value,
      transfertolocationid: selectedTransferToLocation,
      ispo: isPo,
      storeaccountpayment: isStoreAccountPaymentFlag,
      totalquantitypurchased: 0,
      totalquantityreceived: 0,
      discountcomment: discountComment,
      // discountentiresale: discountInputValue,
      discountentiresale: commonDiscount,
      addcouponcodes: couponCode,
      issuspended: 0,
      billno: refrenceno != "" && refrenceno != undefined ? refrenceno : 0,
      duedate: dueDate,
      termsid: termsId,
      receipt: FileUrl,
      tagids: selectedtags != undefined ? selectedtags.toString() : "",
      accountid: accountId,
      shiptocustomer: shipToCustomer,
      shippingadress: shippingAddressText,
      shipvia: shipVia,
      receivingdate: receivingDate,
      supplieremail: emailsuppliers,
      mailingaddress: addresssuppliers,
      balance: balanceAmount,
    };

    // return true;
    //   Send the form data using axios
    axios
      .post(
        `${config.receivingBaseUrl}/receivings/upsert`,
        formValuesDataToSend,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode == "SUCCESS") {
          localStorage.removeItem("Clone");
          localStorage.removeItem("receivingDraft");
          toastSuccess(SUCCESS_MESSAGE);
          setShowModal(true);

          navigate(`/receiving`);
          //navigate(`/receiving-receipt/${res.data.ResponseID}`);
        } else if (res.ResponseCode === "ERROR") {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleCompleteSale = (salestatus) => {
    const amount = parseFloat(amountToSubtract);

    if (salestatus === "complete") {
      if (!amountToSubtract) {
        // display error message
        toast.error("Please enter a valid amount");
        return;
      }

      if (isNaN(amount) || amount <= 0) {
        // display error message
        toast.error("Please enter a valid amount");
        return;
      }

      if (amount > dueAmount) {
        // display error message
        toast.error("The amount entered is greater than the due amount");
        return;
      }
    }

    if (dueAmount > 0 || salestatus === "suspend") {
      // add payment method only if amount due is greater than zero
      // if (isNaN(amount) || amount <= 0) {
      //   // display error message
      //   toast.error("Please enter a valid amount");
      //   return;
      // }
      let payment = {
        PayId: 0,
        PaymentId: selectedPayment.id,
        PaymentAmount: amount,
      };

      let updatedPayments = [...payments];
      if (amount > 0) {
        updatedPayments.push(payment);
      }

      setPayments(updatedPayments);

      originalPass = updatedPayments;
      setDueAmount((prevDueAmount) => prevDueAmount - amount);

      setAmountToSubtract("");
    }
  };

  const handleAmountChange = (event) => {
    let amount = parseFloat(event.target.value);
    if (Number.isNaN(amount)) {
      amount = 0;
    }
    // setAmountToSubtract(event.target.value);
    setAmountToSubtract(amount);
  };

  // it will call when the filter is clicked in the popup
  const callback = (payload) => {
    if (payload != undefined && payload.length > 0) {
      // const newItem = { ...payload[0], itemquantity: 1, UnitPrice: 0 };
      const newItem = { ...payload[0], itemquantity: 1 };
      const existingItemIndex = statenew.findIndex(
        (item) =>
          item.VariationId === newItem.VariationId &&
          item.ItemId === newItem.ItemId
      );
      if (existingItemIndex !== -1) {
        const existingItem = statenew[existingItemIndex];
        existingItem.itemquantity = existingItem.itemquantity + 1;
        existingItem.Total = calculateTotal(
          existingItem.CostPrice,
          existingItem.itemquantity,
          existingItem.itemdiscount
        );

        const updatedDataNew = [...statenew];
        updatedDataNew[existingItemIndex] = existingItem;
        // setStateNew(updatedDataNew);
        setCategoryStateNew(updatedDataNew);
        updatedData = updatedDataNew;
      } else {
        setStateNew([...statenew, newItem]);

        updatedData = statenew.concat(newItem); // add the new item to updatedData
      }

      // add the following code to store items whose Module is "Accounts"
      let categoryItems = [];
      for (let i = 0; i < updatedData.length; i++) {
        const item = updatedData[i];
        if (item.Module === "Accounts") {
          categoryItems.push(item);
        }
      }

      setCategoryStateNew(categoryItems);
      updateTotal(updatedData); // pass updatedData to updateTotal()
    }
    payload = "";
  };

  const callbackItemGrid = (payload) => {
    setRunApi(false);
    // const newItem = { ...payload[0], itemquantity: 1 };
    console.log(payload, "payload");
    // Loop over each item in the payload array
    payload.forEach((newItem) => {
      // Find the index of the item in the statenew array that has the same ItemId
      // const index = statenew.findIndex(
      //   (i) => i.VariationId === item.VariationId
      // );

      const existingItemIndex = statenew.findIndex(
        (item) =>
          item.VariationId === newItem.VariationId &&
          item.ItemId === newItem.ItemId
      );
      if (existingItemIndex !== -1) {
        const existingItem = statenew[existingItemIndex];
        existingItem.itemquantity += 1;
        existingItem.Total = calculateTotal(
          existingItem.CostPrice,
          existingItem.itemquantity,
          existingItem.itemdiscount
        );

        const updatedDataNew = [...statenew];
        updatedDataNew[existingItemIndex] = existingItem;
        updatedData = updatedDataNew;
      } else {
        // Otherwise, add the item with itemquantity 1 to the statenew array
        statenew.push({
          ...newItem,
          itemquantity: 1,
          Total: calculateTotal(newItem.CostPrice, 1, 0),
        });
        updatedData = statenew.concat({
          ...newItem,
          itemquantity: 1,
          Total: calculateTotal(newItem.CostPrice, 1, 0),
        });
        // setStateNew([...statenew, newItem]);
        // updatedData = statenew.concat(newItem); // add the new item to updatedData
      }
    });

    setStateNew(updatedData);
    setStateNew([...statenew]);
    updateTotal(statenew);
    // updateTotal(updatedData);

    //console.log("item ==> updatedData: 1", updatedData);
    // updateTotal(updatedData);

    // setStateNew([...statenew, newItem]);
    // setCategoryStateNew([...categoryStatenew, newItem]);
    // updatedData = statenew.concat(newItem); // add the new item to updatedData

    // // setStateNew(updatedData);

    // // setStateNew([...statenew,]);
    // updateTotal(updatedData);
  };
  //
  const callbackMailingAddress = (payload) => {
    setMailingAddress(payload);
  };

  function calculateTotal(CostPrice, itemquantity, itemdiscount) {
    // const item = statenew[index];
    if (isNaN(CostPrice)) {
      CostPrice = 0;
    }
    if (isNaN(itemquantity)) {
      itemquantity = 0;
    }
    if (isNaN(itemdiscount)) {
      itemdiscount = 0;
    }
    const totalPrice = CostPrice * itemquantity * (1 - itemdiscount / 100);

    return totalPrice;
  }

  const handleCancelClick = (event) => {
    event.preventDefault();
    setSelectedOption(null);
    setEmailsuppliers(null);
    setBalanceSuppliers(null);
    setAddresssuppliers(null);
    setSelectedCustomer([]);
    // setSelectedOption(null);
    // setComment(null)
  };

  const handleEntireReceivingDiscountChange = (event) => {
    const newDiscountValue = Number(event.target.value);
    //setting Value in LS
    const x = { ...localValues, DiscountChange: newDiscountValue };
    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
    setEntireReceivingDiscount(
      isNaN(newDiscountValue) || newDiscountValue == 0 ? 0 : newDiscountValue
    );

    setDiscountInputValue(newDiscountValue == 0 ? "" : newDiscountValue);

    const updatedDataDiscount = statenew.map((item) => {
      let total = calculateTotal(
        item.CostPrice,
        item.itemquantity,
        newDiscountValue
      );
      return { ...item, itemdiscount: newDiscountValue, Total: Number(total) };
    });

    setStateNew(updatedDataDiscount);
    updatedData = updatedDataDiscount;

    updateTotal(updatedData);
  };

  const handleChangeComment = (e) => {
    const x = { ...localValues, bottomComments: e?.target?.value };
    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
    setComment(e.target.value);
  };

  //comments HandleChanges
  const handleChangeDiscountComments = (e) => {
    //setting up the data in LS
    const x = { ...localValues, Comments: e?.target?.value };
    setLocalValues(x);
    if (paramObject.id === undefined) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
    setDiscountComment(e?.target?.value);
  };

  const handleChangeCupon = (e) => {
    setCouponCode(e.target.value);
  };

  //dropdown
  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     zIndex: 99,
  //   }), // dropdown menu css
  // };

  const options = supoptions.map((option) => ({
    value: option.ID,
    label:
      option.CompanyName +
      " (" +
      (option.FirstName + " " + option.LastName) +
      ")",
    email: option.Email,
    address: option.Address,
    balance: option.Balance,
    image: option.Image,
  }));

  //Supplier dropdown
  const handleSelectChange = (event) => {
    let x = { ...localValues, dropdownSuppliers: event };
    setLocalValues(x);
    localStorage.setItem("receivingDraft", JSON.stringify(x));
    setSelectedOption(event);
    setEmailsuppliers(event.email);
    setSupplierId(event.value);
    setBalanceSuppliers(event.balance);
    setAddresssuppliers(event.address);
    // setMailingAddress(event.address);
    // Reset the supplierId to avoid showing the previous card
    // Temporary Commented Supplier Get by Id
    setLoading(true);
    axios
      .get(
        `${config.suppliersBaseUrl}/suppliers/supplierdetailforlabel?supplierids=${event.value}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        if (
          response.data.ResponseData[0] != undefined &&
          response.data.ResponseData[0] != null
        ) {
          let supplierData = response.data.ResponseData[0];
          setSelectedSupplier(supplierData);

          let supplierAddress =
            supplierData.Address1 +
            " " +
            supplierData.Address2 +
            ",\r\n" +
            supplierData.City +
            ",\r\n" +
            supplierData.StateProvince +
            ",\r\n" +
            supplierData.Country +
            ".\r\n" +
            supplierData.Zip;
          setMailingAddress(supplierAddress);
          // setSelectedOption("");
        }

        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  //Persisiting the data in the Local Storage of Suppliers
  const handleDataChange = (sId) => {
    axios
      .get(
        `${config.suppliersBaseUrl}/suppliers/supplierdetailforlabel?supplierids=${sId}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        if (
          response.data.ResponseData[0] != undefined &&
          response.data.ResponseData[0] != null
        ) {
          let supplierData = response.data.ResponseData[0];
          setSelectedSupplier(supplierData);

          let supplierAddress =
            supplierData.Address1 +
            " " +
            supplierData.Address2 +
            ",\r\n" +
            supplierData.City +
            ",\r\n" +
            supplierData.StateProvince +
            ",\r\n" +
            supplierData.Country +
            ".\r\n" +
            supplierData.Zip;
          setMailingAddress(supplierAddress);

          // setSelectedOption("");
        }

        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  //Batch Receiving getData

  // For Receiving Type Dropdown
  let receivingTypeDropdownOption = [];
  const RolesDropdown = receivingTypeDropdown.map((u, i) => {
    receivingTypeDropdownOption[i] = { label: u.ReceivingsType, value: u.ID };
  });

  // for AccountID
  let accountTypeDropdownOption = [];
  const AccountDropdown = chartOfAccountDropdown.map((u, i) => {
    accountTypeDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
      amount: u.Amount,
    };
  });

  console.log(accountTypeDropdownOption, "accountTypeDropdownOption");
  // For Customers
  let customersDropdownOption = [];
  const CustomersDropdown = customersDropdown.map((u, i) => {
    customersDropdownOption[i] = {
      // label: u.FirstName,
      label: u.CompanyName + " (" + (u.FirstName + " " + u.LastName) + ")",
      value: u.Id,
    };
  });

  // For Terms
  let termsDropdownOption = [];
  const TermsDropdown = termsDropdown.map((u, i) => {
    termsDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
      days: u.Value,
    };
  });

  // For Tags
  let tagsDropdownOption = [];
  const tagstypeDropdown = tagsDropdown.map((u, i) => {
    tagsDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  // For Categories
  let categoryDropdownOption = [];
  const categorytypeDropdown = selectedCategory.map((u, i) => {
    categoryDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  const BindPageDropDown = () => {
    axios
      .get(`${config.categoriesBaseUrl}/categories?filtertext=${""}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedCategory(res.data.ResponseData);
      });

    // Accounting Tags Drop Down Axios Call
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setTagsDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // Accounting Terms Drop Down Axios Call
    axios
      .get(`${config.generalBaseUrl}/generals/termsddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        setTermsDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // Dropdown for the Customers
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setCustomersDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // chart of Account Dropdown for account id
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setChartOfAccountDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    // PaymentType Dropdown List
    axios
      .get(`${config.generalBaseUrl}/generals/paymentdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setPaymentTypeDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("Error: ", err);
      });

    // ReceivingType Dropdown List
    axios
      .get(`${config.receivingBaseUrl}/receivings/receivingtypedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setReceivingTypeDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("Error: ", err);
        // setLoading(false);
      });

    axios
      .get(
        `${config.receivingBaseUrl}/receivings/customfieldgetall?receivingid=${Id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // Taking the the custom fields
        setCustomFields(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("Error: ", err);
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSupOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //       const mappedReceivingItems = ReceivingItem.map((item) => {
  //         const mappedItem = {
  //           ReceivingItemID: item.ReceivingItemID,
  //           ItemId: item.ItemId,
  //           ReceivingId: item.ReceivingId,
  //           ItemName: item.Items,
  //           UnitPrice: parseFloat(item.UnitPrice),
  //           CostPrice: parseFloat(item.CostPrice),
  //           itemquantity: parseFloat(item.itemquantity),
  //           itemdiscount: parseFloat(item.itemdiscount),
  //           Ischecked: item.Ischecked,
  //           Total: parseFloat(item.Total),
  //           Module: item.Module,
  //           Itemkitid: item.ItemKitId,
  //           VariationName: item.VariationName,
  //           ItemCurrentQuantity: parseFloat(item.ItemCurrentQuantity),
  //           VariationQuantity: parseFloat(item.VariationQuantity),
  //           Description: item.Description,
  //           VariationId: item.VariationId,
  //           AttributeId: item.AttributeId,
  //           CategoryID: item.CategoryID,
  //           CategoryName: item.CategoryName,
  //           Itemnumber: item.Itemnumber,
  //           Allowaltdescription: item.Allowaltdescription,
  //           IsItemserialnumber: item.IsItemserialnumber,
  //         };
  //         return mappedItem;
  //       });

  //       setStateNew(mappedReceivingItems);

  //       const totalItemQuantity = mappedReceivingItems.reduce(
  //         (a, v) => (a = a + v.itemquantity),
  //         0
  //       );
  //       setTotalQuantity(totalItemQuantity);

  //       setCategoryStateNew(mappedReceivingItems);

  //       // Setting the Total amount
  //       const totalValue = SuspendedData.total;
  //       totalRef.current = parseInt(totalValue).toFixed(2);

  //       // Setting the Amount Due
  //       const dueValue = SuspendedData.AmountDue;
  //       setDueAmount(parseInt(dueValue).toFixed(2));

  //       // Setting the Comment
  //       const commentValue = SuspendedData.Comments;
  //       setComment(commentValue || "");

  //       // setting the Suppliers Id
  //       // const supplierObj = {
  //       //   suppliersvalue: SuspendedData[0].Supplier,
  //       //   suppliersName: SuspendedData[0].Name
  //       // // };
  //       // const suppliersvalue = SuspendedData[0].Supplier;
  //       // const suppliersName = SuspendedData[0].Name;
  //       // setSelectedSupplier(suppliersvalue);
  //       // console.log("suppliersvaluesuppliersvalu/e", suppliersvalue);

  //       // setSupplierName(suppliersName);
  //       // setSupplierId(supplierObj.suppliersvalue);
  //       // setSelectedOption(suppliersvalue);

  //       // setSelectedOption(suppliersName);
  //       const paymentTypeMap = {};
  //       PaymentData.forEach((payment) => {
  //         paymentTypeMap[payment.ID] = payment.Paymenttypename;
  //       });

  //       setPayments(PaymentData);
  //       setSelectedPayment(PaymentData.Paymenttypename);
  //       setPaymentTypeDropdown(PaymentData);

  //       // Reference no.
  //       setRefrenceno(SuspendedData.BillNo);

  //       // Due Date
  //       setDueDate(SuspendedData.DueDate);

  //       //Terms Id
  //       setTermsId(SuspendedData.TermsID);

  //       //Tags Id
  //       const tagIds = SuspendedData.TagIDs;
  //       // for bind the tags values
  //       if (tagIds.length > 0) {
  //         axios
  //           .get(`${config.tagBaseUrl}/tags/tagsdropdown`, {
  //             headers: {
  //               "Content-Type": "application/json;charset=UTF-8",
  //               Authorization: token,
  //             },
  //           })
  //           .then((res) => {
  //             tagsDropdownOption = res.data.ResponseData;
  //             if (tagIds.length > 0) {
  //               tagsDropdownOption.map((selectManufacturer) => {
  //                 const splitSelectedManufacturer = tagIds.split(",");
  //                 // using map() to convert array of strings to numbers
  //                 var splitSelectedManufacturernumbers =
  //                   splitSelectedManufacturer.map(function (str) {
  //                     return parseInt(str);
  //                   });
  //                 setSelectedtags(splitSelectedManufacturernumbers);
  //               });
  //             }
  //           });
  //       }

  //       // setBalanceAmount(SuspendedData.Balance);
  //       setSelectedOption(SuspendedData.Supplier);
  //       setSupplierId(SuspendedData.Supplier);
  //       // setShippingAddress(SuspendedData.ShipingAddress);
  //       setshippingAddressText(SuspendedData.ShipingAddress);
  //       setAddresssuppliers(SuspendedData.MailingAddress);
  //       setEmailsuppliers(SuspendedData.SupplierEmail);
  //       setSupplierName(SuspendedData.Name);

  //       console.log("SupplierDetail ==>", SupplierDetail);
  //       setSelectedSupplier(SupplierDetail);

  //       //Account Id
  //       setAccountId(SuspendedData.AccountID);
  //       setFileUrl(SuspendedData.Receipt);
  //       setShipToCustomer(SuspendedData.ShipToCustomer);
  //       setShipVia(SuspendedData.ShipVia);

  //       setCouponCode(SuspendedData.AddCouponCodes);
  //       setPaymentCurrency(SuspendedData.PaymentCurreny);

  //       setDiscountComment(SuspendedData.DiscountComment);
  //       // setEntireReceivingDiscount(SuspendedData.DiscountEntireSale);
  //       setCommonDiscount(SuspendedData.DiscountEntireSale);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  // const handleOptionSelect = (e, label, value) => {
  //   console.log("value", value);
  //   setSelectedReceiveDropdown(value);
  //   let eve = e.target;
  //   const dataItemId = eve.getAttribute("value");
  //   const receiveType = dataItemId;
  //   setReceivingTypeId(value);
  //   setSelect(label);
  //   setIsTransfer(label === "Transfer");
  //   setIsStoreAccountPayment(label === "Supplier Account");
  //   const selectedOption = receivingTypeDropdownOption.find(
  //     (option) => option.value == receiveType
  //   );

  //   let o = selectedOption.label;
  //   setSelectedReceiveOption(o);

  //   setIsPo(1);
  //   if (receiveType != 1) {
  //     setIsPo(0);
  //   }

  //   setIsStoreAccountPaymentFlag(0);
  //   if (receiveType === 6) {
  //     setIsStoreAccountPaymentFlag(1);
  //   }
  // };

  useEffect(() => {
    setSelectedReceiveDropdown(1);
    if (localStorage.getItem("openpageexpenses")) {
      setSelectedReceiveDropdown(7);
      setReceivingTypeId(7);
      setSelectedReceiveOption("Expense");
      localStorage.removeItem("openpageexpenses");
    }

    if (localStorage.getItem("showTransfer")) {
      setShowTranser(true);
      localStorage.removeItem("showTransfer");
    }

    BindPageDropDown();
    // BindReceivingPageDetails();

    // if (paramObject.id > 0) {
    //   alert("Param Object ID is available");
    // }

    // if (paramObject.id > 0) {
    //   //let paramid = paramObject.id > 0 ? paramObject.id : Clone;
    //   const alertElement = (
    //     <div
    //       className="ms-3 mb-3 alert alert-danger"
    //       style={{ width: "95%" }}
    //       role="alert"
    //     >
    //       {" "}
    //       Editing Receiving RECV {paramObject.id}
    //     </div>
    //   );
    //   ReactDOM.render(alertElement, document.getElementById("alert")); // Replace 'root' with the ID of the element where you want to display the alert
    // }
  }, []);

  // const showLocationError = () => {
  //   if (!transferFromLocation) {
  //     toastError("Please select location")
  //     return
  //   }
  //   if (!transferToLocation) {
  //     toastError("Please select location")
  //     return
  //   }
  // }

  useEffect(() => {
    // if(selectedReceiveDropdown ==4 && paramObject.id > 0){
    //   BindReceivingPageDetails();
    //   console.log(1);
    // }
    // let paramid = paramObject.id > 0 ? paramObject.id : Clone;
    //localStorage.removeItem("Clone");
    let paramid = 0;
    if (paramObject.id > 0 || Clone > 0) {
      paramid = paramObject.id > 0 ? paramObject.id : Clone;
      localStorage.removeItem("Clone");
    }
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/listofsuspendrecordByidv2?id=${paramid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const SuspendedData = res.data.ResponseData.unSuspendData[0];
        const PaymentData = res.data.ResponseData.paymentData;
        const ReceivingItem = res.data.ResponseData.receivingItem;
        const SupplierDetail = res.data.ResponseData.supplierdetail[0];
        const paymentAmounts = PaymentData.map((payment) =>
          parseFloat(payment.PaymentAmount)
        );
        const totalPaidAmount = paymentAmounts.reduce(
          (acc, curr) => acc + curr,
          0
        );
        // statenew
        // setStateNew(ReceivingItem);
        setSelectedReceiveOption(SuspendedData.ReceivingsType);
        setRestrictEdit(SuspendedData.RestrictEdit);
        setReceivingTypeId(SuspendedData.ReceiveType);
        setSelectedReceiveDropdown(SuspendedData.ReceiveType);
        setPaidAmount(totalPaidAmount.toFixed(2));
        setSelectedLocation(SuspendedData.LocationId);
        setSelectedTransferToLocation(SuspendedData.TransfertoLocationId);
        setIsTransfer(SuspendedData.ReceivingsType === "Transfer");
        // setSelectedLocation(SuspendedData.)
        setIsReadOnly(false);
        const mappedReceivingItems = ReceivingItem.map((item) => {
          const mappedItem = {
            ReceivingItemID: Clone > 0 ? 0 : item.ReceivingItemID,
            ItemId: item.ItemId,
            ReceivingId: Clone > 0 ? 0 : Clone,
            ItemName: item.Items,
            UnitPrice: parseFloat(item.UnitPrice),
            CostPrice: parseFloat(item.CostPrice),
            itemquantity: parseFloat(item.itemquantity),
            itemdiscount: parseFloat(item.itemdiscount),
            Ischecked: item.Ischecked,
            Total: parseFloat(item.Total),
            Module: item.Module,
            Itemkitid: item.ItemKitId,
            VariationName: item.VariationName,
            ItemCurrentQuantity: parseFloat(item.ItemCurrentQuantity),
            VariationQuantity: parseFloat(item.VariationQuantity),
            Description: item.Description,
            VariationId: item.VariationId,
            AttributeId: item.AttributeId,
            CategoryID: item.CategoryID,
            CategoryName: item.CategoryName,
            Itemnumber: item.Itemnumber,
            Allowaltdescription: item.Allowaltdescription,
            IsItemserialnumber: item.IsItemserialnumber,
          };
          return mappedItem;
        });

        setStateNew(mappedReceivingItems);
        // statenew
        const totalItemQuantity = mappedReceivingItems.reduce(
          (a, v) => (a = a + v.itemquantity),
          0
        );
        setTotalQuantity(totalItemQuantity);

        setCategoryStateNew(mappedReceivingItems);

        // Setting the Total amount
        const totalValue = SuspendedData.total;
        totalRef.current = parseFloat(totalValue).toFixed(2);
        setPaymentAmount(totalValue);

        // Setting the Amount Due
        const dueValue = SuspendedData.AmountDue;
        setDueAmount(parseFloat(dueValue).toFixed(2));

        // Setting the Comment
        const commentValue = SuspendedData.Comments;
        setComment(commentValue || "");

        // setting the Suppliers Id
        // const supplierObj = {
        //   suppliersvalue: SuspendedData[0].Supplier,
        //   suppliersName: SuspendedData[0].Name
        // // };
        // const suppliersvalue = SuspendedData[0].Supplier;
        // const suppliersName = SuspendedData[0].Name;
        // setSelectedSupplier(suppliersvalue);
        // console.log("suppliersvaluesuppliersvalu/e", suppliersvalue);

        // setSupplierName(suppliersName);
        // setSupplierId(supplierObj.suppliersvalue);
        // setSelectedOption(suppliersvalue);

        // setSelectedOption(suppliersName);
        const paymentTypeMap = {};
        PaymentData.forEach((payment) => {
          paymentTypeMap[payment.ID] = payment.Paymenttypename;
        });

        setPayments(PaymentData);
        setSelectedPayment(PaymentData.Paymenttypename);
        setPaymentTypeDropdown(PaymentData);

        // Reference no.
        setRefrenceno(SuspendedData.BillNo);

        // Due Date
        // console.log(moment(SuspendedData.DueDate).format("YYYY-MM-DD"), "suspendedData for due")
        setDueDate(moment(SuspendedData.DueDate).format("YYYY-MM-DD"));

        //Terms Id
        setTermsId(SuspendedData.TermsID);

        // setBalanceAmount(SuspendedData.Balance);
        setSelectedOption(SuspendedData.Supplier);
        setSupplierId(SuspendedData.Supplier);

        setshippingAddressText(SuspendedData.ShipingAddress);
        setAddresssuppliers(SuspendedData.MailingAddress);
        setEmailsuppliers(SuspendedData.SupplierEmail);
        setSupplierName(SuspendedData.Name);

        setSelectedSupplier(SupplierDetail);

        //Account Id
        setAccountId(SuspendedData.AccountID);
        setFileUrl(SuspendedData.Receipt);
        setShipToCustomer(SuspendedData.ShipToCustomer);
        setShipVia(SuspendedData.ShipVia);

        setCouponCode(SuspendedData.AddCouponCodes);
        setPaymentCurrency(SuspendedData.PaymentCurreny);

        setDiscountComment(SuspendedData.DiscountComment);
        // setEntireReceivingDiscount(SuspendedData.DiscountEntireSale);
        setCommonDiscount(SuspendedData.DiscountEntireSale);

        setTransferToLocation(SuspendedData.TransfertoLocationId);
        setTransferFromLocation(SuspendedData.LocationId);

        //Tags Id
        const tagIds = SuspendedData.TagIDs;
        // for bind the tags values
        if (tagIds != null && tagIds != undefined && tagIds != "") {
          axios
            .get(`${config.tagBaseUrl}/tags/tagsdropdown`, {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: token,
              },
            })
            .then((res) => {
              tagsDropdownOption = res.data.ResponseData;
              if (tagIds != "") {
                tagsDropdownOption.map((selectManufacturer) => {
                  const splitSelectedManufacturer = tagIds.split(",");
                  // using map() to convert array of strings to numbers
                  var splitSelectedManufacturernumbers =
                    splitSelectedManufacturer.map(function (str) {
                      return parseInt(str);
                    });
                  setSelectedtags(splitSelectedManufacturernumbers);
                });
              }
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let updatedData = [];

  const handleCommonDiscountChange = (event) => {
    const newDiscountValue = Number(event.target.value);

    setCommonDiscount(newDiscountValue == 0 ? "" : newDiscountValue);

    let newTotal = 0;
    statenew.forEach((item, index) => {
      let totalPrice = 0;
      let CostPrice = item.CostPrice;
      if (isNaN(item.CostPrice)) {
        CostPrice = 0;
      }
      let itemdiscount = item.itemdiscount;
      if (isNaN(item.itemdiscount)) {
        itemdiscount = 0;
      }
      if (!isNaN(item.CostPrice) && !isNaN(item.itemdiscount)) {
        totalPrice =
          item.CostPrice * item.itemquantity * (1 - item.itemdiscount / 100);
      }
      totalPrice = CostPrice * item.itemquantity * (1 - itemdiscount / 100);
      newTotal = parseFloat(newTotal) + parseFloat(totalPrice);
    });

    const totalAmount = Number(newTotal) - newDiscountValue;

    // newTotal = newTotal - Number(commonDiscount);
    totalRef.current = totalAmount;

    if (paramObject.id === undefined) {
      const x = {
        ...localValues,
        Total: totalAmount,
        CommonDiscountLS: newDiscountValue,
      };
      setLocalValues(x);
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }

    let paymentTotal = totalAmount - paidAmount;
    // console.log("setDueAmount ", paymentTotal);
    if (isNaN(paymentTotal)) {
      paymentTotal = 0;
    }
    setDueAmount(paymentTotal);
  };

  const [description, setDescription] = useState("");
  // For the category description change
  const handleCategoryDescriptionChange = (index, value) => {
    //Saving data in LS
    if (paramObject.id == undefined) {
      const x = { ...localValues, Description: value };
      setLocalValues(x);
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }

    updatedData = [...categoryStatenew];
    updatedData[index] = { ...updatedData[index], Description: value };
    setCategoryStateNew(updatedData);

    updateTotal(updatedData);
  };

  // For handling the category amount Change
  const handleCategoryAmountChange = (index, value) => {
    updatedData = [...categoryStatenew];
    updatedData[index] = {
      ...updatedData[index],
      CostPrice: Number(value),
      Total: Number(value),
    };

    setCategoryStateNew(updatedData);
    updateTotal(updatedData);
    setStateNew(updatedData);
  };

  // For the Price change
  const handlePriceChange = (index, value) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      CostPrice: value == 0 || value < 0 ? "" : Number(value),
    };

    let total = calculateTotal(
      updatedData[index].CostPrice,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: Number(total) };

    setStateNew(updatedData);
    updateTotal(updatedData);
  };

  const handleSellingChange = (index, value) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      UnitPrice: value == 0 || value < 0 ? "" : Number(value),
    };
    setStateNew(updatedData);
    updateTotal(updatedData);
  };

  // For handling the Quantity Change
  const handleQuantityChange = (index, value) => {
    updatedData = [...statenew];
    let itemCurrentQuantity = updatedData[index].ItemCurrentQuantity;
    // if (value === "" || Number(value) <= itemCurrentQuantity) {
    // const newValidationErrors = [...validationErrors];
    // newValidationErrors[index] = "";
    // setValidationErrors(newValidationErrors);

    updatedData[index] = {
      ...updatedData[index],
      itemquantity: value == 0 ? "" : parseInt(value),
    };
    let total = calculateTotal(
      updatedData[index].CostPrice,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: Number(total) };
    setStateNew(updatedData);
    updateTotal(updatedData);
    // }
    // else {
    // add error message from the use state
    // const newValidationErrors = [...validationErrors];
    // newValidationErrors[index] =
    //   "Value must not exceed " + itemCurrentQuantity;
    // setValidationErrors(newValidationErrors);
    // }
  };

  // For Handling the discount Change
  const handleDiscountChange = (index, value) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      itemdiscount: value == 0 ? "" : Number(value),
    };

    let total = calculateTotal(
      updatedData[index].CostPrice,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: Number(total) };

    setStateNew(updatedData);
    updateTotal(updatedData);
    setDiscountInputValue(value);
  };

  // Handle for the Delete Action Button
  const handleItemsDelete = (index) => {
    const newImageUrls = statenew.filter((_, i) => i !== index);
    setStateNew(newImageUrls);
    updatedData = newImageUrls;
    updateTotal(newImageUrls);
    setSelectedPayment([]);
    setPayments([]);
    // setDueAmount(0);
  };

  const handleCheckboxChange = (e, index) => {
    updatedData = [...statenew];
    updatedData[index] = {
      ...updatedData[index],
      IsChecked: e.target.checked == true ? 1 : 0,
    };
    setStateNew(updatedData);
    setCheckboxes(e.target.checked == true ? 1 : 0);
  };

  const handleCategoryItemsDelete = (index) => {
    const NewCategoryList = categoryStatenew.filter((_, i) => i !== index);
    setStateNew(NewCategoryList);
    setCategoryStateNew(NewCategoryList);
    updatedData = NewCategoryList;
    updateTotal(NewCategoryList);
    setSelectedPayment([]);
    setPayments([]);
    // setDueAmount(0);
  };

  useEffect(() => {
    const paymentTotal = totalRef.current - dueAmount;
    setPaidAmount(paymentTotal > 0 ? paymentTotal.toFixed(2) : 0);
  }, [dueAmount]);

  function updateTotal(updatedData) {
    // console.log(updatedData, "updatedData")
    let newTotalQuantity = 0;
    updatedData.forEach((item) => {
      newTotalQuantity += Number(item.itemquantity);
    });
    if (selectedReceiveDropdown !== 5 && selectedReceiveDropdown !== 7) {
      setTotalQuantity(newTotalQuantity);
    }

    let newTotal = 0;
    updatedData.forEach((item, index) => {
      let totalPrice = 0;
      let CostPrice = item.CostPrice;
      if (isNaN(item.CostPrice)) {
        CostPrice = 0;
      }
      let itemdiscount = item.itemdiscount;
      if (isNaN(item.itemdiscount)) {
        itemdiscount = 0;
      }
      totalPrice = CostPrice * item.itemquantity * (1 - itemdiscount / 100);
      newTotal = parseFloat(newTotal) + parseFloat(totalPrice);
    });

    totalRef.current = newTotal;
    let paymentTotal = newTotal - paidAmount;

    if (isNaN(paymentTotal)) {
      paymentTotal = 0;
    }
    setDueAmount(paymentTotal);
  }

  const _handleFileChange = (e) => {
    setChangeImagename(true);

    if (validation(e.target.name, e?.currentTarget?.files[0])) {
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };
  const validation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    await uploadAWS(file, AWS_IMAGE_FOLDER_RECEIVING, (data) => {
      if (data) {
        if (type === "SelectImage") setImageUrl(data);
        else {
          customFieldReceivingValues[type] = {
            CustomFieldLabelID: type,
            CustomFieldValue: data,
          };
          setCustomFileUrl(data);
          setLoading(false);
        }
      }
    });
  };

  // const handleCheck = () => {
  //   setAddresssuppliers(addresssuppliers);
  //   setShowEdit(false);
  // };

  // const handleClose = () => {
  //   setShowEdit(false);
  // };

  const handleSelectCustomCheckBox = () => {
    setSelectCustomCheckBox(!selectCustomCheckBox);
  };
  const handleCustomFieldsValues = (event, fieldTypeName, fieldName) => {
    if (fieldTypeName === "Dropdown") {
      customFieldReceivingValues[fieldName] = {
        CustomFieldLabelID: fieldName,
        CustomFieldValue: event.label,
        CustomFieldLabel: event.selectedValue,
      };
    } else if (fieldTypeName === "Checkbox") {
      customFieldReceivingValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.checked,
        CustomFieldLabel: fieldName,
      };
    }

    // else if (fieldName === "E-Mail") {
    //   customFieldReceivingValues[event.target.name] = {CustomFieldLabelID: event.target.name,CustomFieldValue: event.target.value};
    // } else if (fieldName === "Website") {
    //   customFieldReceivingValues[event.target.name] = {CustomFieldLabelID: event.target.name,CustomFieldValue: event.target.value};
    // } else if (fieldName === "PhoneNumber") {
    //   customFieldReceivingValues[event.target.name] = {CustomFieldLabelID: event.target.name,CustomFieldValue: event.target.value};
    // } else if (fieldName === "Date") {
    //   customFieldReceivingValues[event.target.name] = {CustomFieldLabelID: event.target.name,CustomFieldValue: event.target.value};
    // }
    else {
      // console.log("fieldTypeName: ",fieldTypeName, "fieldName: ", fieldName, "value: ", event.target.name,event.target.value, "1122" )
      customFieldReceivingValues[event.target.name] = {
        CustomFieldLabelID: event.target.name,
        CustomFieldValue: event.target.value,
        CustomFieldLabel: fieldName,
      };
    }
  };

  const handleItemsDetailsData = (itemDetails) => {
    // setItemsDetailsData(itemDetails.ItemId);
    setItemsDetailsData(itemDetails);
  };

  //Removing data from the local Storage
  const handleRemoveLocalData = () => {
    navigate("/receiving");
    localStorage.removeItem("receivingDraft");
  };

  // Handle change for the Payment method
  const handelpaymentAmount = (e) => {
    setPaymentAmount(e.target.value);
    if (paramObject.id === undefined) {
      const x = { ...localValues, paymentAmount: e.target.value };
      setLocalValues(x);
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
  };
  // add receiving buttens
  const handleSuspendClick = (e, optiondata) => {
    // console.log("valueeee", e.target);
    setSelectedReceiveDropdown(optiondata.value);

    // let eve = e.target;
    // const dataItemId = eve.getAttribute("value");
    // const saleType = dataItemId;
    setReceivingTypeId(optiondata.value);
    setSelect(optiondata.label);
    setIsStoreAccountPayment(optiondata.label === "Customer Account");
    const selectedOption = receivingTypeDropdownOption.find(
      (option) => option.value == optiondata.value
    );

    let o = selectedOption.label;

    setSelectedReceiveOption(o);

    // console.log("selectedOption =>", o);
    // console.log("selectedOption ===========>", selectedOption);

    // BindInvoiceDropdown(optiondata.value);
    // setSelectDropDownValue()
  };

  const SubmitShippingAddress = (e) => {
    e.preventDefault();
    // console.log(e.target[0].value, "shipping address updated")
    handleChangeAccountSalesData(e.target[0].value, "ShippingAddress");
    setShippingEditAddrerss(false);
  };

  //For persisting Data in LocalStorage

  // useEffect(() => {
  //   const savedData = localStorage.getItem("receivingDraft");
  //   console.log(savedData, "savedData")
  //   if (savedData) {
  //     const parsedData = JSON.parse(savedData);
  //     setLocalValues(parsedData);
  //     setSelectedLocation(parsedData.locationWarehouseDropdown);
  //     setSelectedTransferToLocation()
  //     // console.log(selectedReceiveDropdown, "SelectedReceiveDropdown 4545")
  //     // // console.log(parsedData?.receivingDropdown[0], "SelectedReceiveDropdown 4545")
  //     if (parsedData?.receivingDropdown != undefined) {
  //       setSelectedReceiveDropdown(parsedData?.receivingDropdown[0]);
  //       setIsTransfer(parsedData?.receivingDropdown[1] === "Transfer");
  //     }
  //     let checkdropdown;
  //     if (parsedData?.receivingDropdown != undefined) {
  //       setSelectedReceiveDropdown(parsedData?.receivingDropdown[0]);
  //       setSelectedReceiveOption(parsedData?.receivingDropdown[1]);
  //       setReceivingTypeId(parsedData?.receivingDropdown[0]);
  //       checkdropdown =  parsedData?.receivingDropdown[0]
  //     }
  //     setSelectedtags(parsedData.Tags)
  //     setRefrenceno(parsedData.referenceno)
  //     setshippingAddressText(parsedData.ShippingAddress)
  //     setShipToCustomer(parsedData.ShipToCustomer)
  //     setShipVia(parsedData.ShipVia)
  //     setSupplierId(parsedData?.dropdownSuppliers?.value)
  //     setSelectedOption(parsedData?.dropdownSuppliers)
  //     setTimeout(() => {
  //       setTermsId(parsedData.TermsID);
  //     }, 2000);
  //     setTimeout(() => {
  //       setAccountId(parsedData.AccountId)
  //     }, 2000);
  //     handleDataChange(parsedData?.dropdownSuppliers?.value)
  //     setStateNew((checkdropdown === 5 || checkdropdown == 7) ? parsedData?.expenseDropdown :  parsedData?.inputDropdown)
  //     setCategoryStateNew(parsedData?.expenseDropdown)
  //     setEntireReceivingDiscount(parsedData?.DiscountChange)
  //     setCommonDiscount(parsedData?.CommonDiscountLS == undefined ? 0 : parsedData?.CommonDiscountLS)
  //     setDiscountComment(parsedData?.Comments)
  //     setPaymentAmount(parsedData?.paymentAmount)
  //     setDescription(parsedData?.Description)
  //     setFileUrl(parsedData?.Attachment)
  //   }
  // }, []);

  useEffect(() => {
    const savedData = localStorage.getItem("receivingDraft");

    if (savedData) {
      const parsedData = JSON.parse(savedData);
      setLocalValues(parsedData);
      setSelectedLocation(parsedData.locationWarehouseDropdown);
      setSelectedTransferToLocation(parsedData.transferLocationChange);
      // console.log(selectedReceiveDropdown, "SelectedReceiveDropdown 4545")
      // // console.log(parsedData?.receivingDropdown[0], "SelectedReceiveDropdown 4545")
      if (parsedData?.receivingDropdown != undefined) {
        setSelectedReceiveDropdown(parsedData?.receivingDropdown[0]);
        setIsTransfer(parsedData?.receivingDropdown[1] === "Transfer");
      }
      let checkdropdown;
      if (parsedData?.receivingDropdown != undefined) {
        setSelectedReceiveDropdown(parsedData?.receivingDropdown[0]);
        setSelectedReceiveOption(parsedData?.receivingDropdown[1]);
        setReceivingTypeId(parsedData?.receivingDropdown[0]);
        checkdropdown = parsedData?.receivingDropdown[0];
      }
      setSelectedtags(parsedData.Tags);
      setRefrenceno(parsedData.referenceno);
      setshippingAddressText(parsedData.ShippingAddress);
      setShipToCustomer(parsedData.ShipToCustomer);
      setShipVia(parsedData.ShipVia);
      setSupplierId(parsedData?.dropdownSuppliers?.value);
      setSelectedOption(parsedData?.dropdownSuppliers);
      setTimeout(() => {
        setTermsId(parsedData.TermsID);
      }, 2000);
      setTimeout(() => {
        setAccountId(parsedData.AccountId);
      }, 2000);
      handleDataChange(parsedData?.dropdownSuppliers?.value);
      setStateNew(
        checkdropdown === 5 || checkdropdown == 7
          ? parsedData?.expenseDropdown
          : parsedData?.inputDropdown
      );
      setCategoryStateNew(parsedData?.expenseDropdown);
      setEntireReceivingDiscount(parsedData?.DiscountChange);
      setCommonDiscount(
        parsedData?.CommonDiscountLS == undefined
          ? 0
          : parsedData?.CommonDiscountLS
      );
      setDiscountComment(parsedData?.Comments);
      setPaymentAmount(parsedData?.paymentAmount);
      setDescription(parsedData?.Description);
      setFileUrl(parsedData?.Attachment);
      setComment(parsedData?.bottomComments);
      setReceivingDate(
        parsedData?.receivingDate === undefined
          ? today.format("YYYY-MM-DD")
          : parsedData?.receivingDate
      );
      setDueDate(parsedData?.DueDate);
    }
  }, []);

  const updateLocalValues = (statenew) => {
    const localValue1 =
      JSON.parse(localStorage.getItem("receivingDraft")) || "";
    const x = { ...localValue1, inputDropdown: statenew };
    setLocalValues(x);
    if (selectedReceiveDropdown !== 5 && selectedReceiveDropdown !== 7) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
  };

  const updateLocalValues1 = (categoryStatenew) => {
    const localValue1 =
      JSON.parse(localStorage.getItem("receivingDraft")) || "";

    const x = { ...localValue1, expenseDropdown: categoryStatenew };
    setLocalValues(x);
    if (selectedReceiveDropdown === 5 || selectedReceiveDropdown == 7) {
      localStorage.setItem("receivingDraft", JSON.stringify(x));
    }
  };

  useEffect(() => {
    if (paramObject.id === undefined) {
      updateLocalValues(statenew);
    }
  }, [statenew]);

  useEffect(() => {
    if (paramObject.id === undefined) {
      updateLocalValues1(categoryStatenew);
    }
  }, [categoryStatenew]);

  // console.log(selectedReceiveDropdown, "SelectedReceiveDropdown 4545")
  // console.log(statenew,"statenew2263")

  //LS Total Amount

  //  let LStotalAmt;
  //  if(selectedReceiveDropdown == 5 || selectedReceiveDropdown == 7){
  //   LStotalAmt = JSON.parse(localStorage.getItem("receivingDraft"))||0;
  //    LStotalAmt = LStotalAmt?.expenseDropdown?.reduce((acc, cur) => {

  //      acc += +(cur.Total);
  //      return acc;
  //    }, 0)
  //  }
  // else{

  return (
    <>
      {/* <ToastContainer /> */}
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h5 className="page-title">Receiving</h5>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/receiving">Receiving List</Link>
                </li>
                <li className="breadcrumb-item active">Manage Receiving</li>
              </ul>
            </div>
          </div>
        </div>

        <div>
          {paramObject.id > 0 && <div id="alert"></div>}
          {/* rest of your JSX code */}
        </div>

        {/* Header */}
        <div className="row ms-2 me-2">
          <div className="col-md-8">
            <div className="card" style={{ padding: "0px 5px 0 5px" }}>
              <div className="card-body" style={{ padding: "5px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "bold",
                    color: "red",
                  }}
                >
                  <div className="p-2 col-md-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-success dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      // value={receivingTypeId}
                      // defaultValue={1}
                    >
                      {selectedReceiveOption}
                    </button>

                    <ul className="dropdown-menu">
                      {receivingTypeDropdownOption.map((option, index) => (
                        // {console.log("option", option)}
                        <li key={index}>
                          <a
                            value={option.value}
                            className="dropdown-item"
                            onClick={(event) =>
                              handleOptionSelect(
                                event,
                                option.label,
                                option.value
                              )
                            }
                          >
                            {option.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                  {restirctedit == 1 &&
                    (selectedReceiveDropdown == 2 ||
                      selectedReceiveDropdown == 7) && (
                      <div
                        style={{
                          border: "1px solid",
                          padding: "5px 10px",
                          borderRadius: "5px",
                        }}
                      >
                        Payment transaction has been intiated, so you can't
                        update the record.
                      </div>
                    )}
                  {/* {(selectedReceiveDropdown == 1 ||
                    selectedReceiveDropdown == 2 ||
                    selectedReceiveDropdown == 3 ||
                    selectedReceiveDropdown == 5 ||
                    selectedReceiveDropdown == 7) && (
                      <div className="p-2 col-md-9">
                        <Select
                          placeholder="WareHouse"
                          className="w-100"
                          options={locationDropdownOption}
                          styles={selectStyles}
                          onChange={(e) => handleLocationChange(e)}
                          value={locationDropdownOption.find(
                            (option) => option?.value == selectedLocation
                          )}
                        />
                      </div>
                    )} */}
                </div>

                {selectedReceiveDropdown != 6 && (
                  <>
                    <div className="d-flex row mt-2">
                      <div className="col-md-7 ml-2">
                        Tags:
                        <Select
                          id="Tags"
                          name="Tags"
                          onChange={(event) => {
                            handleChangeAccountSalesData(event, "Tags");
                          }}
                          options={tagsDropdownOption}
                          value={tagsDropdownOption?.filter((obj) =>
                            selectedtags?.includes(obj.value)
                          )}
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          isClearable={true}
                          isMulti={true}
                          styles={selectStyles}
                          className="custom-search-select"
                        />
                      </div>
                      <div className="col-md-4 ml-2">
                        Receipt:
                        <input
                          type="file"
                          className="form-control form-control-sm"
                          id="Receipt"
                          name="Receipt"
                          onChange={handleFileChange}
                        />
                        {FileUrl && (
                          <Link to={FileUrl} target="_blank">
                            Attachment Link
                          </Link>
                        )}
                      </div>
                    </div>
                  </>
                )}

                {(selectedReceiveDropdown == 1 ||
                  selectedReceiveDropdown == 2 ||
                  selectedReceiveDropdown == 3 ||
                  selectedReceiveDropdown == 4 ||
                  selectedReceiveDropdown == 5 ||
                  selectedReceiveDropdown == 7) && (
                  <>
                    <div className="d-flex flex-row">
                      {/* Reference no. */}
                      {(selectedReceiveDropdown == 2 ||
                        selectedReceiveDropdown == 5 ||
                        selectedReceiveDropdown == 7) && (
                        <div className="p-2 col-md-3">
                          Ref no.
                          <input
                            type="text"
                            id="referenceno"
                            name="referenceno"
                            placeholder="Reference No."
                            className="form-control form-control-sm"
                            value={refrenceno}
                            onChange={(event) => {
                              handleChangeAccountSalesData(
                                event,
                                "referenceno"
                              );
                            }}
                          />
                        </div>
                      )}

                      {/* Bill Date */}
                      {(selectedReceiveDropdown == 1 ||
                        selectedReceiveDropdown == 2 ||
                        selectedReceiveDropdown == 3 ||
                        selectedReceiveDropdown == 4 ||
                        selectedReceiveDropdown == 5 ||
                        selectedReceiveDropdown == 7) && (
                        <>
                          <div className="p-2 col-md-3">
                            <span>
                              {selectedReceiveDropdown == 1
                                ? "Purchase Order Date"
                                : selectedReceiveDropdown == 2
                                ? "Receive Date"
                                : selectedReceiveDropdown == 3
                                ? "Return Date"
                                : selectedReceiveDropdown == 5
                                ? "Payment Date"
                                : selectedReceiveDropdown == 4
                                ? "Transfer Date"
                                : selectedReceiveDropdown == 7
                                ? "Expense Date"
                                : ""}
                            </span>
                            <div className="form-group">
                              <input
                                type="date"
                                id="receivingDate"
                                name="receivingDate"
                                placeholder="Select Date"
                                className="form-control form-control-sm"
                                // defaultValue={receivingDate}
                                value={receivingDate}
                                // defaultValue={today.format("YYYY-MM-DD")}
                                onChange={(event) =>
                                  handleChangeAccountSalesData(
                                    event,
                                    "receivingDate"
                                  )
                                }
                              />
                            </div>
                          </div>
                        </>
                      )}

                      {/* Due Date */}
                      {selectedReceiveDropdown == 2 && (
                        <>
                          {/* Terms  */}
                          <div className="p-2 col-md-3">
                            Terms:
                            <Select
                              id="TermsID"
                              name="TermsID"
                              onChange={(event) =>
                                handleChangeAccountSalesData(event, "TermsID")
                              }
                              value={termsDropdownOption.find(
                                (option) => option?.value == termsId //selectedTerm
                              )}
                              options={termsDropdownOption}
                              backspaceRemovesValue={false}
                              // controlShouldRenderValue={true}
                              // isClearable={true}
                              styles={selectStyles}
                              className="custom-search-select"
                              //hideSelectedOptions={true}
                            />
                          </div>

                          <div className="p-2 col-md-3">
                            Due Date:
                            <input
                              type="date"
                              id="DueDate"
                              name="DueDate"
                              className="form-control form-control-sm"
                              value={dueDate}
                              onChange={(event) =>
                                handleChangeAccountSalesData(event, "DueDate")
                              }
                            />
                          </div>
                        </>
                      )}

                      {(selectedReceiveDropdown == 1 ||
                        selectedReceiveDropdown == 3) && (
                        <>
                          {/* Ship to Customer: */}
                          <div className="p-2 col-md-6 ">
                            Ship to Customer:
                            <Select
                              id="ShipToCustomer"
                              name="ShipToCustomer"
                              onChange={(event) => {
                                handleChangeAccountSalesData(
                                  event,
                                  "ShipToCustomer"
                                );
                              }}
                              value={customersDropdownOption.find(
                                (option) => option?.value == shipToCustomer
                              )}
                              options={customersDropdownOption}
                              backspaceRemovesValue={false}
                              styles={selectStyles}
                              className="custom-search-select"
                            />
                          </div>

                          {/* Ship Via: */}
                          <div className="p-2 col-md-3">
                            Ship Via:
                            <input
                              type="text"
                              id="ShipVia"
                              name="ShipVia"
                              placeholder="Ship Via"
                              className="form-control form-control-sm"
                              value={shipVia}
                              onChange={(event) =>
                                handleChangeAccountSalesData(event, "ShipVia")
                              }
                            />
                          </div>
                        </>
                      )}

                      {selectedReceiveDropdown == 7 && (
                        <>
                          {/* AccountId */}
                          <div className="p-2 col-md-4">
                            Account:
                            <Select
                              id="AccountId"
                              name="AccountId"
                              onChange={(event) => {
                                handleChangeAccountSalesData(
                                  event,
                                  "AccountId"
                                );
                                setBalanceAmount(event?.amount);
                              }}
                              options={accountTypeDropdownOption?.filter(
                                (el) => el.value == 4
                              )}
                              value={accountTypeDropdownOption?.find(
                                (option) => option?.value == accountId
                              )}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              styles={selectStyles}
                              className="custom-search-select"
                            />
                          </div>
                          {balanceAmount && (
                            <>
                              <div className="p-2 col-md-3">
                                <div className="d-flex flex-column">
                                  <div className="p-1">
                                    <label>Balance: </label>
                                  </div>
                                  <div className="p-1">
                                    <span>
                                      <strong>{balanceAmount}</strong>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="card col-md-12">
              <div className="card-body">
                {(selectedReceiveDropdown == 1 ||
                  selectedReceiveDropdown == 2 ||
                  selectedReceiveDropdown == 3 ||
                  selectedReceiveDropdown == 4 ||
                  selectedReceiveDropdown == 5 ||
                  selectedReceiveDropdown == 6 ||
                  selectedReceiveDropdown == 7) && (
                  <>
                    {toggleItemsFilterSection && (
                      <>
                        <div className="d-flex flex-row mt-2">
                          {/* Search Invoice Below */}
                          <div className="p-2 col-md-6">
                            Item
                            <input
                              type="text"
                              id="SearchInvoice"
                              name="SearchInvoice"
                              placeholder="Search Pick List Item"
                              className="form-control"
                              value={searchValue}
                              onChange={handleSearchInputChange}
                            />
                          </div>

                          {/* Filter Category */}
                          {selectedReceiveDropdown !== 5 &&
                            selectedReceiveDropdown !== 7 && (
                              <div className="p-2 col-md-6">
                                Category
                                <Select
                                  placeholder="Filter Pick List Item"
                                  id="Filtercategory"
                                  name="Filtercategory"
                                  options={categoryDropdownOption}
                                  backspaceRemovesValue={false}
                                  controlShouldRenderValue={true}
                                  hideSelectedOptions={true}
                                  isClearable={true}
                                  styles={selectStyles}
                                  onChange={(event) => {
                                    handleForCategorySearch(event);
                                  }}
                                />
                              </div>
                            )}
                        </div>
                        {/* <div className="p-2 col-md-2">
                          {(selectedReceiveDropdown == 1 ||
                            selectedReceiveDropdown == 2 ||
                            selectedReceiveDropdown == 3 ||
                            selectedReceiveDropdown == 4 ||
                            selectedReceiveDropdown == 6) && (
                            <div>
                              {selectedReceiveDropdown !== 6 && (
                                <Link
                                  type="button"
                                  className="btn btn-outline-primary w-100"
                                  data-bs-target={
                                    selectedOption != null
                                      ? "#exampleModal"
                                      : ""
                                  }
                                  onClick={(e) =>
                                    selectedOption == null
                                      ? toastError("Select Supplier First")
                                      : ""
                                  }
                                  // data-bs-target="#exampleModal"
                                  data-bs-toggle="modal"
                                >
                                  <i className="fa fa-filter me-1"></i> Item
                                  Grid
                                </Link>
                              )}
                            </div>
                          )}
                        </div> */}
                        {/* <div className="p-2 col-md-2">
                          {selectedReceiveDropdown !== 6 && (
                            <Link
                              type="button"
                              className="btn btn-outline-dark w-100"
                              onClick={() =>
                                setToggleItemsFilterSection(
                                  !toggleItemsFilterSection
                                )
                              }
                            >
                              {!toggleItemsFilterSection ? (
                                <>
                                  <i className="fa fa-arrow-up me-1"></i>
                                  Filter
                                </>
                              ) : (
                                <>
                                  <i className="fa fa-arrow-down me-1"></i>
                                  Filter
                                </>
                              )}
                            </Link>
                          )}
                        </div> */}
                      </>
                    )}

                    <div className="d-flex flex-row mt-2">
                      <div className="p-2 col-md-7">
                        {selectedReceiveDropdown !== 6 && (
                          <React.Fragment>
                            {selectedOption?.value ? (
                              <SearchableDropdown
                                SupplierID={supplierId}
                                callback={callback}
                                options={options}
                                selectedReceiveDropdown={
                                  selectedReceiveDropdown == 5 ||
                                  selectedReceiveDropdown == 7
                                    ? 1
                                    : 0
                                }
                              />
                            ) : (
                              <SearchableDropdown
                                SupplierID={supplierId}
                                callback={callback}
                                options={options}
                                selectedReceiveDropdown={
                                  selectedReceiveDropdown == 5 ||
                                  selectedReceiveDropdown == 7
                                    ? 1
                                    : 0
                                }
                                readonly={
                                  selectedReceiveDropdown == 4
                                    ? false
                                    : isReadOnly
                                }
                              />
                            )}
                          </React.Fragment>
                        )}
                      </div>
                      <div className="p-2 col-md-3 item">
                        {(selectedReceiveDropdown == 1 ||
                          selectedReceiveDropdown == 2 ||
                          selectedReceiveDropdown == 3 ||
                          selectedReceiveDropdown == 4 ||
                          selectedReceiveDropdown == 6) && (
                          <div>
                            {selectedReceiveDropdown !== 6 && (
                              <Link
                                type="button"
                                className="btn btn-outline-primary w-100"
                                data-bs-target={
                                  selectedOption != null
                                    ? "#exampleModal"
                                    : null
                                }
                                onClick={() => {
                                  setRunApi(true);
                                  if (selectedOption == null) {
                                    toastError("Select Supplier First");
                                  }
                                }}
                                data-bs-toggle="modal"
                              >
                                <i className="fa fa-filter me-1"></i> Item Grid
                              </Link>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="p-2 col-md-2">
                        {selectedReceiveDropdown !== 6 && (
                          <Link
                            type="button"
                            className="btn btn-outline-dark w-100"
                            onClick={() =>
                              setToggleItemsFilterSection(
                                !toggleItemsFilterSection
                              )
                            }
                          >
                            {!toggleItemsFilterSection ? (
                              <>
                                <i className="fa fa-arrow-up me-1"></i>
                                Filter
                              </>
                            ) : (
                              <>
                                <i className="fa fa-arrow-down me-1"></i>
                                Filter
                              </>
                            )}
                          </Link>
                        )}
                      </div>
                    </div>
                    {selectedReceiveDropdown !== 6 &&
                      selectedReceiveDropdown !== 7 && (
                        <div className="d-flex flex-row mt-2">
                          <div className="col-md-12 ">
                            <div className="form-check form-switch mb-3 pull-right">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="toggle-button"
                                checked={isContentVisible}
                                onClick={() =>
                                  setIsContentVisible(!isContentVisible)
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="toggle-button"
                              >
                                {isContentVisible
                                  ? "Disable Pick List"
                                  : "Enable Pick List"}
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                  </>
                )}

                {/* For Item and Item Kits */}
                {(selectedReceiveDropdown == 1 ||
                  selectedReceiveDropdown == 2 ||
                  selectedReceiveDropdown == 3 ||
                  selectedReceiveDropdown == 4 ||
                  selectedReceiveDropdown == 6) && (
                  <div className="row">
                    <div className="col-md-12">
                      {/* <div> */}
                      <div className="table-responsive">
                        <table
                          className="table custom-table"
                          // style={{ width: "1024px" }}
                        >
                          <thead>
                            <tr>
                              {selectedReceiveDropdown !== 6 &&
                                (showRowInternalDetails ? (
                                  <th
                                    style={{ width: "50px" }}
                                    onClick={(e) => handleShowDetails(e)}
                                  >
                                    <i class="fa fa-minus"></i> No.
                                  </th>
                                ) : (
                                  <th
                                    style={{ width: "50px" }}
                                    onClick={(e) => handleShowDetails(e)}
                                  >
                                    <i class="fa fa-plus"></i> No.
                                  </th>
                                ))}
                              {selectedReceiveDropdown === 6 && (
                                <th style={{ width: "50px" }}>Item Name</th>
                              )}
                              {/* {selectedReceiveDropdown !== 6 && (
                                  <th>Item Name</th>
                                )} */}
                              {selectedReceiveDropdown === 6 && (
                                <th style={{ width: "250px" }}>
                                  Payment Amount
                                </th>
                              )}
                              {selectedReceiveDropdown !== 6 && (
                                <th style={{ width: "150px" }}>Cost Price</th>
                              )}
                              {selectedReceiveDropdown !== 6 && (
                                <th style={{ width: "120px" }}>Qty</th>
                              )}
                              {selectedReceiveDropdown !== 6 && (
                                <th style={{ width: "120px" }}>Disc.(%)</th>
                              )}
                              {selectedReceiveDropdown !== 6 && (
                                <th style={{ width: "120px" }}> Total</th>
                              )}
                              {selectedReceiveDropdown !== 6 && (
                                <th
                                  style={{ width: "50px" }}
                                  className="text-center"
                                ></th>
                              )}
                              {selectedReceiveDropdown !== 6 && (
                                <th
                                  style={{ width: "50px" }}
                                  className="text-center"
                                >
                                  {isContentVisible && (
                                    <input
                                      className="form-check-input form-control"
                                      type="checkbox"
                                      name="CheckBox"
                                      id="CheckBox"
                                      onChange={(e) => {
                                        const checkboxes =
                                          document.querySelectorAll(
                                            'tbody input[type="checkbox"]'
                                          );
                                        checkboxes.forEach((checkbox) => {
                                          checkbox.checked = e.target.checked;
                                        });
                                      }}
                                    />
                                  )}
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {selectedReceiveDropdown === 6 && (
                              <tr>
                                <td>
                                  {/* <Link
                                    type="button"
                                    data-bs-target="#StoreAccountPaymentModal"
                                    data-bs-toggle="modal"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  > */}
                                  Supplier Account
                                  {/* </Link> */}
                                </td>

                                <StoreAccountPaymentModal />
                                <td>
                                  <input
                                    id="paymentamount"
                                    name="paymentamount"
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={paymentAmount}
                                    onChange={(e) => handelpaymentAmount(e)}
                                  />
                                </td>
                              </tr>
                            )}

                            {statenew
                              ?.filter(
                                (item) =>
                                  item.Module !== "Accounts" &&
                                  item.ItemName?.toLowerCase().includes(
                                    searchValue?.toLowerCase()
                                  ) &&
                                  (selectedCategoryForSearch
                                    ? item.CategoryID ===
                                      selectedCategoryForSearch
                                    : true)
                              )
                              .map((item, index) => {
                                const filteredIndex = statenew.indexOf(item);
                                console.log(item, "3275");
                                return (
                                  <>
                                    <tr
                                      className={
                                        "gridrow-" +
                                        (filteredIndex % 2 ? "even" : "odd")
                                      }
                                    >
                                      {(selectedReceiveDropdown == 1 ||
                                        selectedReceiveDropdown == 2 ||
                                        selectedReceiveDropdown == 3 ||
                                        selectedReceiveDropdown == 4 ||
                                        selectedReceiveDropdown == 5 ||
                                        selectedReceiveDropdown == 7) && (
                                        <>
                                          <td rowSpan={2}>
                                            {filteredIndex + 1}
                                          </td>
                                          <td colSpan={7} className="p-1">
                                            <Link
                                              type="button"
                                              onClick={(e) =>
                                                handleItemsDetailsData(item)
                                              }
                                              data-bs-target="#ItemsDetailsModal"
                                              data-bs-toggle="modal"
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <p className="word-break-data font-semibold">
                                                {item.VariationName != "" &&
                                                item.VariationName != null
                                                  ? item.VariationName
                                                  : item.ItemName}
                                              </p>
                                            </Link>
                                          </td>
                                        </>
                                      )}
                                    </tr>
                                    <tr
                                      key={item.modifyid}
                                      className={
                                        "gridrow-" +
                                        (filteredIndex % 2 ? "even" : "odd")
                                      }
                                    >
                                      {selectedReceiveDropdown !== 6 && (
                                        <>
                                          {/* <td>{filteredIndex + 1}</td> */}
                                          {/* <td>
                                              <Link
                                                type="button"
                                                onClick={(e) =>
                                                  handleItemsDetailsData(item)
                                                }
                                                data-bs-target="#ItemsDetailsModal"
                                                data-bs-toggle="modal"
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <p className="word-break-data">
                                                  {item.VariationName != "" ? item.VariationName : item.ItemName}
                                                </p>
                                              </Link>
                                            </td> */}
                                        </>
                                      )}

                                      {selectedReceiveDropdown !== 6 && (
                                        <td className="table-control-td">
                                          <span className="table-control-lable">
                                            Cost Price
                                          </span>
                                          <input
                                            type="number"
                                            value={item.CostPrice}
                                            className="form-control form-control-sm"
                                            onChange={(e) =>
                                              handlePriceChange(
                                                filteredIndex,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                      )}
                                      {selectedReceiveDropdown !== 6 && (
                                        <td className="table-control-td">
                                          <span className="table-control-lable">
                                            Qty
                                          </span>
                                          <input
                                            type="number"
                                            value={item.itemquantity}
                                            // min={1}
                                            // max={item.ItemCurrentQuantity}
                                            className="form-control form-control-sm"
                                            onChange={(e) =>
                                              handleQuantityChange(
                                                filteredIndex,
                                                e.target.value
                                              )
                                            }
                                          />

                                          {/* {validationErrors[filteredIndex] && (
                                            <p className="text-danger">
                                              {validationErrors[filteredIndex]}
                                            </p>
                                          )} */}
                                        </td>
                                      )}
                                      {selectedReceiveDropdown !== 6 && (
                                        <td className="table-control-td">
                                          <span className="table-control-lable">
                                            Discount
                                          </span>
                                          <input
                                            type="number"
                                            value={item.itemdiscount}
                                            className="form-control form-control-sm"
                                            onChange={(e) =>
                                              handleDiscountChange(
                                                filteredIndex,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                      )}
                                      {selectedReceiveDropdown !== 6 && (
                                        <td className="table-control-td">
                                          <span className="table-control-lable">
                                            Total
                                          </span>
                                          <input
                                            type="number"
                                            // value={calculateTotal(item.UnitPrice, item.itemquantity, item.itemdiscount)}
                                            value={item.Total}
                                            className="form-control form-control-sm"
                                            onChange={(e) =>
                                              handleTotalChange(
                                                filteredIndex,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td>
                                        // <td>
                                        //   {calculateTotal(
                                        //     item.UnitPrice,
                                        //     item.itemquantity,
                                        //     item.itemdiscount
                                        //   )}
                                        // </td>
                                      )}
                                      {/* <td></td> */}

                                      {selectedReceiveDropdown !== 6 && (
                                        <td>
                                          <Link
                                            className="confirm-text"
                                            to="#"
                                            title="Delete"
                                            style={{ fontSize: "12px" }}
                                            onClick={() =>
                                              handleItemsDelete(index)
                                            }
                                          >
                                            <i
                                              className="fa fa-trash text-red fa-2x"
                                              data-bs-toggle="tooltip"
                                              title="Delete"
                                            ></i>
                                          </Link>
                                        </td>
                                      )}
                                      {selectedReceiveDropdown !== 6 && (
                                        <td>
                                          {isContentVisible && (
                                            <input
                                              className="form-check-input form-control"
                                              // style={{
                                              //   width: "1.5em",
                                              //   height: "1.5em",
                                              // }}
                                              type="checkbox"
                                              name={`CheckBox${index}`}
                                              id={`CheckBox${index}`}
                                              // checked={item.Ischecked === 1}
                                              defaultChecked={item.Ischecked}
                                              // checked={checkboxes[index] || false}
                                              onChange={(e) =>
                                                handleCheckboxChange(e, index)
                                              }
                                            />
                                          )}
                                        </td>
                                      )}
                                    </tr>
                                    {(selectedReceiveDropdown == 1 ||
                                      selectedReceiveDropdown == 2 ||
                                      selectedReceiveDropdown == 3 ||
                                      selectedReceiveDropdown == 4 ||
                                      selectedReceiveDropdown == 5 ||
                                      selectedReceiveDropdown == 7) && (
                                      <tr
                                        className={
                                          "gridrow-" +
                                          (filteredIndex % 2 ? "even" : "odd")
                                        }
                                      >
                                        {showRowInternalDetails && (
                                          <td colSpan={8} className="p-0">
                                            <div className="d-flex bottom-table">
                                              <span className="m-2 word-break-data">
                                                Category: {item?.CategoryName}
                                              </span>
                                              <span className="m-2">
                                                Stock:{" "}
                                                {item?.ItemCurrentQuantity ==
                                                undefined
                                                  ? 0
                                                  : item?.ItemCurrentQuantity}
                                              </span>
                                              <span className="m-2">
                                                UPC/EAN/ISBN:{" "}
                                                {item?.Itemnumber == undefined
                                                  ? "-"
                                                  : item?.Itemnumber}
                                              </span>
                                              <span className="m-2">
                                                Selling Price:{" "}
                                              </span>
                                              <input
                                                type="number"
                                                value={item?.UnitPrice}
                                                onChange={(e) =>
                                                  handleSellingChange(
                                                    filteredIndex,
                                                    e.target.value
                                                  )
                                                }
                                                className="form-control mt-2"
                                                style={{
                                                  width: "100px",
                                                  height: "23px",
                                                  "font-size": "12px",
                                                  "font-weight": "bold",
                                                  "background-color": "#EEE",
                                                }}
                                                readOnly
                                              />
                                            </div>
                                          </td>
                                        )}
                                      </tr>
                                    )}
                                  </>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                      {/* </div> */}
                    </div>
                  </div>
                )}

                {(selectedReceiveDropdown == 7 ||
                  selectedReceiveDropdown == 5) && (
                  <div className="col-md-12 mt-2">
                    <div>
                      <div className="table-responsive">
                        <table className="table table-striped custom-table">
                          <thead>
                            <tr>
                              <th>No.</th>
                              <th>Category</th>
                              <th>Description</th>
                              <th>Amount</th>
                              <th>Delete</th>
                              {isContentVisible &&
                                selectedReceiveDropdown !== 7 && (
                                  <th>
                                    <input
                                      className="form-check-input form-control"
                                      // style={{ width: "1.5em", height: "1.5em" }}
                                      type="checkbox"
                                      name="CheckAll"
                                      id="CheckAll"
                                      onChange={(e) => {
                                        const checkboxes =
                                          document.querySelectorAll(
                                            'tbody input[type="checkbox"]'
                                          );
                                        checkboxes.forEach((checkbox) => {
                                          checkbox.checked = e.target.checked;
                                        });
                                      }}
                                    />
                                  </th>
                                )}
                            </tr>
                          </thead>
                          <tbody>
                            {categoryStatenew
                              ?.filter(
                                (item) =>
                                  item.Module == "Accounts" &&
                                  item.ItemName?.toLowerCase().includes(
                                    searchValue?.toLowerCase()
                                  )
                              )
                              .map((item, index) => {
                                const filteredIndex =
                                  categoryStatenew.indexOf(item);
                                return (
                                  <>
                                    <tr key={item.modifyid}>
                                      <td>{filteredIndex + 1}</td>
                                      <td>{item.ItemName}</td>
                                      <td>
                                        <input
                                          type="text"
                                          value={item.Description}
                                          className="form-control"
                                          onChange={(e) =>
                                            handleCategoryDescriptionChange(
                                              filteredIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          value={item.CostPrice}
                                          className="form-control"
                                          onChange={(e) =>
                                            handleCategoryAmountChange(
                                              filteredIndex,
                                              e.target.value
                                            )
                                          }
                                        />
                                      </td>
                                      {/* <td></td> */}
                                      <td>
                                        <Link
                                          className="confirm-text"
                                          to="#"
                                          title="Delete"
                                          style={{ fontSize: "12px" }}
                                          onClick={() =>
                                            handleCategoryItemsDelete(index)
                                          }
                                        >
                                          <i
                                            className="fa fa-trash text-red fa-2x"
                                            data-bs-toggle="tooltip"
                                            title="Delete"
                                          ></i>
                                        </Link>
                                      </td>
                                      {/* <td>
                                        {isContentVisible && selectedReceiveDropdown !== 7 && (
                                          <input
                                            type="text"
                                            value={item.Description}
                                            className="form-control" 
                                            onChange={(e) =>
                                              handleCategoryDescriptionChange(
                                                filteredIndex,
                                                e.target.value
                                              )
                                            }
                                          />
                                        )}
                                        </td> */}
                                      {/* <td>
                                          <input
                                            type="number"
                                            value={item.CostPrice}
                                            className="form-control"
                                            onChange={(e) =>
                                              handleCategoryAmountChange(
                                                filteredIndex,
                                                e.target.value
                                              )
                                            }
                                          />
                                        </td> */}
                                      {/* <td></td> */}
                                      {/* <td>
                                          <Link
                                            className="confirm-text"
                                            to="#"
                                            title="Delete"
                                            style={{ fontSize: "12px" }}
                                            onClick={() =>
                                              handleCategoryItemsDelete(index)
                                            }
                                          >
                                            <i
                                              className="fa fa-trash text-red fa-2x"
                                              data-bs-toggle="tooltip"
                                              title="Delete"
                                            ></i>
                                          </Link>
                                        </td> */}
                                      <td>
                                        {isContentVisible &&
                                          selectedReceiveDropdown !== 7 && (
                                            <input
                                              className="form-check-input form-control"
                                              // style={{
                                              //   width: "1.5em",
                                              //   height: "1.5em",
                                              // }}
                                              type="checkbox"
                                              name={`CheckBox${index}`}
                                              id={`CheckBox${index}`}
                                              defaultChecked={item.Ischecked}
                                              onChange={(e) =>
                                                handleCheckboxChange(e, index)
                                              }
                                            />
                                          )}
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
                {/* </div> */}
              </div>
            </div>

            {/* <div className="card">
              <div className="card-body">
                <div className="p-2">
                  Receipt:
                  <input
                    type="file"
                    className="form-control"
                    id="Receipt"
                    name="Receipt"
                    onChange={handleFileChange}
                  />
                  {FileUrl == "" ? (
                    ""
                  ) : (
                    <Link to={FileUrl} target="_blank">
                      Attachment Link
                    </Link>
                  )}
                </div>
              </div>
            </div> */}
          </div>
          {/* Right Side Content */}
          <div className="col-md-4">
            <div className="card">
              <div className="card-body ">
                <div>
                  <button
                    className="btn btn-sm btn-outline-primary w-100  mb-2"
                    style={{ textAlign: "center" }}
                    onClick={handleRemoveLocalData}
                  >
                    Clear All Data
                  </button>
                </div>
                <div className="">
                  {/* hide suspend and cancel  */}
                  {(selectedReceiveDropdown == 1 ||
                    selectedReceiveDropdown == 2 ||
                    selectedReceiveDropdown == 3 ||
                    selectedReceiveDropdown == 4) && (
                    <div className="row">
                      {statenew && statenew.length > 0 ? (
                        <>
                          <div
                            className="col-md-4"
                            // onClick={handleSuspend}
                          >
                            {/* <button
                                className="btn btn-sm btn-outline-primary ms-1 mb-2"
                                data-bs-target="#SuspendedModal"
                                data-bs-toggle="modal"
                              // onClick={() => {
                              //   // handleSuspendedPopup();
                              //   handleCompleteSale("suspend");
                              // }}
                              >
                                <div className="d-inline-flex align-items-center">
                                  <i class="fas fa-solid fa-pause me-1"></i>
                                  Suspend
                                </div>
                              </button> */}
                          </div>
                          {/* <div className="col-md-4">
                              <button
                                className="btn  btn-sm btn-outline-primary ms-1 mb-2"
                                data-bs-toggle="modal"
                                data-bs-target="#CancelModal"
                                onClick={() => handleCancelPopup()}
                              >
                                <div className="d-flex align-items-center">
                                  <img
                                    src={Closed}
                                    alt="img"
                                    style={{
                                      marginRight: "0.5rem",
                                      width: "0.9rem",
                                      height: "0.9rem",
                                    }}
                                  />
                                  Cancel
                                </div>
                              </button>
                            </div> */}
                        </>
                      ) : null}
                    </div>
                  )}
                </div>

                {!isTransfer ? (
                  <div>
                    {!selectedOption ? (
                      <div className="input-group flex-nowrap">
                        {selectedOption}
                        <span className="input-group-text" id="addon-wrapping">
                          <Link to="/manage-suppliers">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-person-plus"
                              viewBox="0 0 16 16"
                            >
                              <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H1s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C9.516 10.68 8.289 10 6 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
                              <path
                                fillRule="evenodd"
                                d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"
                              />
                            </svg>
                          </Link>
                        </span>

                        <Select
                          className="w-100"
                          name="supplierid"
                          id="supplierid"
                          placeholder="Select a Supplier"
                          options={options}
                          styles={selectStyles}
                          value={selectedOption}
                          onChange={(e) => {
                            setSelectedOption(e);
                            handleSelectChange(e);
                            //console.log("event::>", e);
                          }}
                        />
                      </div>
                    ) : (
                      <>
                        {/* <ReceivingCard
                          value={selectedOption}
                          onCancel={handleCancelClick}
                        /> */}
                        <ReceivingCard
                          data={selectedsupplier}
                          onCancel={handleCancelClick}
                          visible={selectedsupplier.Id === supplierId}
                          callback={callbackMailingAddress}
                        />
                      </>
                    )}

                    {/* Mailing Address: */}
                    {selectedReceiveDropdown !== 6 && (
                      <div className="mb-2 col-md-12 mt-2">
                        {/* Mailing Address: */}
                        {/* {
                          showEdit ? (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <textarea
                              id="MailingAddress"
                              name="MailingAddress"
                              placeholder="Mailing Address"
                              onChange={(event) =>
                                handleChangeAccountSalesData(
                                  event,
                                  "MailingAddress"
                                )
                              }
                              value={addresssuppliers}
                              className="form-control h-100"
                            ></textarea>
                            <AiOutlineCheck
                              style={{ width: "40px" }}
                              onClick={handleCheck}
                            />
                            <GrFormClose
                              style={{ width: "40px", fontSize: "20px" }}
                              onClick={handleClose}
                            />
                          </div>
                        ) : (
                          <div>
                            <p>
                              {addresssuppliers}
                              <i
                                onClick={() => setShowEdit(true)}
                                className="fa fa-edit text-warning fa-1x"
                                style={{ marginLeft: "10px" }}
                              ></i>
                            </p>
                          </div>
                        )
                        } */}
                      </div>
                    )}
                    {/* Shipping Address: */}
                    {selectedReceiveDropdown !== 6 && (
                      // <div className="mb-2 col-md-12">
                      //   Shipping Address:
                      //   <div>
                      //     {shippingEditAddrerss ? (
                      //       <form
                      //         onSubmit={SubmitShippingAddress}
                      //         className="d-flex"
                      //         style={{
                      //           display: "flex",
                      //           alignItems: "center",
                      //           border: "1px solid lightgray",
                      //           borderRadius: "5px",
                      //           width: "auto",
                      //         }}
                      //       >
                      //         <input
                      //           id="ShippingAddress"
                      //           name="ShippingAddress"
                      //           placeholder="Shipping Address"
                      //           className="form-control h-100"
                      //           // value={shippingAddress}
                      //           // onChange={(event) => {
                      //           //   handleChangeAccountSalesData(
                      //           //     event,
                      //           //     "ShippingAddress"
                      //           //   );
                      //           // }}
                      //           defaultValue={shippingAddressText}
                      //           style={{ border: "none" }}
                      //         ></input>
                      //         <button
                      //           className="btn btn-outline-primary btn-sm m-1"
                      //           type="submit"
                      //         >
                      //           <i
                      //             className="fa fa-check"
                      //             aria-hidden="true"
                      //           ></i>
                      //         </button>
                      //         <div
                      //           className="btn btn-outline-danger btn-sm m-1"
                      //           onClick={() => setShippingEditAddrerss(false)}
                      //         >
                      //           <i
                      //             className="fa fa-times"
                      //             aria-hidden="true"
                      //           ></i>
                      //         </div>
                      //       </form>
                      //     ) : shippingAddressText == "" ? (
                      //       <div>
                      //         <i
                      //           class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                      //           aria-hidden="true"
                      //         ></i>
                      //         <></>
                      //         <i
                      //           className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                      //           style={{ fontSize: "16px", cursor: "pointer" }}
                      //           onClick={() => setShippingEditAddrerss(true)}
                      //         ></i>
                      //       </div>
                      //     ) : (
                      //       <>
                      //         <i
                      //           class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                      //           aria-hidden="true"
                      //         ></i>
                      //         {shippingAddressText}
                      //         <i
                      //           className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                      //           style={{ fontSize: "16px", cursor: "pointer" }}
                      //           onClick={() => setShippingEditAddrerss(true)}
                      //         ></i>
                      //       </>
                      //     )}
                      //   </div>
                      // </div>
                      <div className="accordion-item">
                        <div
                          className="accordion-header"
                          style={{ cursor: "pointer" }}
                          onClick={toggleAccordion}
                        >
                          <button
                            class="accordion-button dropdown-toggle"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            Shipping Address
                          </button>
                        </div>
                        {isAccordionOpen && (
                          <div className="accordion">
                            <div className="mb-2 col-md-12">
                              <div>
                                {shippingEditAddrerss ? (
                                  <form
                                    onSubmit={SubmitShippingAddress}
                                    className="d-flex"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      border: "1px solid lightgray",
                                      borderRadius: "5px",
                                      width: "auto",
                                    }}
                                  >
                                    <input
                                      id="ShippingAddress"
                                      name="ShippingAddress"
                                      placeholder="Shipping Address"
                                      className="form-control h-100"
                                      // value={shippingAddress}
                                      // onChange={(event) => {
                                      //   handleChangeAccountSalesData(
                                      //     event,
                                      //     "ShippingAddress"
                                      //   );
                                      // }}
                                      defaultValue={shippingAddressText}
                                      style={{ border: "none" }}
                                    ></input>
                                    <button
                                      className="btn btn-outline-primary btn-sm m-1"
                                      type="submit"
                                    >
                                      <i
                                        className="fa fa-check"
                                        aria-hidden="true"
                                      ></i>
                                    </button>
                                    <div
                                      className="btn btn-outline-danger btn-sm m-1"
                                      onClick={() =>
                                        setShippingEditAddrerss(false)
                                      }
                                    >
                                      <i
                                        className="fa fa-times"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </form>
                                ) : shippingAddressText == "" ? (
                                  <div>
                                    <i
                                      className="fa fa-map-marker text-danger fa-1x ml-2 p-2"
                                      aria-hidden="true"
                                    ></i>
                                    <></>
                                    <i
                                      className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                      style={{
                                        fontSize: "16px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        setShippingEditAddrerss(true)
                                      }
                                    ></i>
                                  </div>
                                ) : (
                                  <>
                                    <i
                                      class="fa fa-commenting fa-1x ml-2 p-2 text-danger"
                                      aria-hidden="true"
                                    ></i>
                                    {shippingAddressText}
                                    <i
                                      className="fa fa-pencil text-warning fa-1x ml-2 p-2"
                                      style={{
                                        fontSize: "16px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        setShippingEditAddrerss(true)
                                      }
                                    ></i>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="row">
                    <div className="col-md-12 mt-2">
                      <div className="input-group">
                        <div className="input-group flex-nowrap ">
                          <span
                            className="input-group-text"
                            id="addon-wrapping"
                          >
                            <Link to="/manage-locations">
                              <i class="fas fa-solid fa-plus"></i>
                            </Link>
                          </span>
                          <Select
                            className="w-100"
                            options={locationDropdownOption}
                            styles={selectStyles}
                            // onChange={handleLocationChange}
                            onChange={(e) => handleLocationChange(e)}
                            value={locationDropdownOption.find(
                              (option) => option?.value == selectedLocation
                            )}
                            placeholder="Transfer From Location"
                          />
                        </div>
                      </div>
                      <div className="col-md-12 mt-3">
                        <div className="input-group">
                          <span
                            className="input-group-text"
                            id="addon-wrapping"
                          >
                            <Link to="/manage-locations">
                              <i class="fas fa-solid fa-plus"></i>
                            </Link>
                          </span>
                          <Select
                            className="w-100"
                            options={locationDropdownOption}
                            styles={selectStyles}
                            // value={selectedTransferToLocation}
                            value={locationDropdownOption.find(
                              (option) =>
                                option?.value == selectedTransferToLocation
                            )}
                            // onChange={handleTransferToLocationChange}
                            onChange={(e) => handleTransferToLocationChange(e)}
                            placeholder="Transfer To Location"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="card col-md-12">
              <div className="card-body">
                {(selectedReceiveDropdown == 1 ||
                  selectedReceiveDropdown == 2 ||
                  selectedReceiveDropdown == 3 ||
                  selectedReceiveDropdown == 4) && (
                  <div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label className="form-label">
                          Discount all Items by Percent (%):
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          id="entirediscount"
                          name="entirediscount"
                          placeholder="Discount"
                          className="form-control form-control-sm"
                          value={entireReceivingDiscount}
                          onChange={handleEntireReceivingDiscountChange}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label className="form-label">
                          Discount Entire Receiving:
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="number"
                          id="discount"
                          name="discount"
                          placeholder="Discount"
                          className="form-control form-control-sm"
                          value={commonDiscount}
                          onChange={handleCommonDiscountChange}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label className="form-label">Discount Comment:</label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          id="comment"
                          name="comment"
                          placeholder="Comment"
                          className="form-control form-control-sm"
                          value={discountComment}
                          onChange={handleChangeDiscountComments}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <label
                          className="form-label"
                          name="SubTotal"
                          id="SubTotal"
                        >
                          Sub Total:
                        </label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          id="SubTotal"
                          name="SubTotal"
                          className="form-control form-control-sm"
                          // value={Number(totalRef.current).toFixed(2)}
                          value={
                            paramObject.id !== undefined
                              ? Number(totalRef.current).toFixed(2)
                              : Number(
                                  (LStotalAmt == undefined ? 0 : LStotalAmt) -
                                    commonDiscount
                                ).toFixed(2)
                          }
                        />
                        {/* {totalRef.current.toFixed(2)} */}
                        {/* {totalRef.current} */}
                      </div>
                    </div>
                  </div>
                )}
                <div className="row mt-2">
                  <div className="col-md-6">
                    <div className="amount-box">
                      <div
                        className="amount-box-header"
                        name="Total"
                        id="Total"
                      >
                        Total
                      </div>
                      {(selectedReceiveDropdown == 1 ||
                        selectedReceiveDropdown == 2 ||
                        selectedReceiveDropdown == 3 ||
                        selectedReceiveDropdown == 4 ||
                        selectedReceiveDropdown == 5 ||
                        selectedReceiveDropdown == 7) && (
                        <div className="amount-box-content">
                          <div
                            className="amount-box-value"
                            data-speed="1000"
                            data-currency="$"
                            data-decimals="2"
                          >
                            {paramObject.id === undefined ? (
                              selectedReceiveDropdown == 5 ||
                              selectedReceiveDropdown == 7 ? (
                                <>${amountForVendor}</>
                              ) : (
                                <>
                                  $
                                  {LStotalAmt == undefined
                                    ? 0
                                    : (LStotalAmt - commonDiscount)?.toFixed(2)}
                                </>
                              )
                            ) : (
                              <>{parseFloat(totalRef.current).toFixed(2)}</>
                            )}
                            {/* {totalRef.current.toFixed(2)}  */}
                            {/* {parseFloat(totalRef.current).toFixed(2)} */}
                          </div>
                        </div>
                      )}
                      {/* {selectedReceiveDropdown == 5|| selectedReceiveDropdown == 7  && (
                        <div className="amount-box-content">
                          <div
                            className="amount-box-value"
                            data-speed="1000"
                            data-currency="$"
                            data-decimals="2"
                          >
                            

                      
                          </div>
                        </div>
                      )} */}
                      {selectedReceiveDropdown == 6 && (
                        <div className="amount-box-content">
                          <div
                            className="amount-box-value"
                            data-speed="1000"
                            data-currency="$"
                            data-decimals="2"
                          >
                            {isNaN(parseFloat(paymentAmount))
                              ? "0.00"
                              : parseFloat(paymentAmount).toFixed(2)}
                            {/* {parseFloat(paymentAmount).toFixed(2)} */}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* For Total Items and Total Quantity */}
                  <div className="col-md-6">
                    {selectedReceiveDropdown == 1 ||
                    selectedReceiveDropdown == 2 ||
                    selectedReceiveDropdown == 3 ||
                    selectedReceiveDropdown == 4 ||
                    selectedReceiveDropdown == 5 ||
                    selectedReceiveDropdown == 6 ||
                    selectedReceiveDropdown == 7 ? (
                      <div className="row mt-3">
                        {(selectedReceiveDropdown == 1 ||
                          selectedReceiveDropdown == 2 ||
                          selectedReceiveDropdown == 3 ||
                          selectedReceiveDropdown == 4) && (
                          <div>
                            <div className="col-md-12">
                              <label className="form-label">Total Item:</label>
                              <span className="ms-5">
                                {
                                  statenew?.filter(
                                    (item) => item.Module !== "Accounts"
                                  ).length
                                }
                              </span>
                            </div>

                            <div className="col-md-12">
                              <label className="form-label">
                                Total Quantity:
                              </label>
                              {paramObject.id == undefined ? (
                                <span className="ms-4">
                                  {LSItemtotalQty == undefined
                                    ? 0
                                    : LSItemtotalQty}
                                </span>
                              ) : (
                                <span className="ms-4">{totalQuantity}</span>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="amount-box">
                        <div className="amount-box-header">Amount Due</div>
                        <div className="amount-box-content">
                          <div className="amount-box-value1">
                            {parseFloat(dueAmount).toFixed(2)}
                            {/* {dueAmount.toFixed(2)} */}
                            {/* ${(totalRef.current - totalRef.current).toFixed(2)} */}
                            {/* $0.00 */}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* For Payment Method */}
                <div>
                  {statenew && statenew.length > 0 ? (
                    <div>
                      {selectedReceiveDropdown == 1 ||
                      selectedReceiveDropdown == 2 ||
                      selectedReceiveDropdown == 3 ||
                      selectedReceiveDropdown == 4 ||
                      selectedReceiveDropdown == 5 ||
                      selectedReceiveDropdown == 6 ||
                      selectedReceiveDropdown == 7 ? (
                        ""
                      ) : (
                        <ul className="list-group payments">
                          {payments.map(
                            (payment, index) =>
                              deletedPaymentIndex !== index && (
                                <li
                                  key={index}
                                  className="list-group-item d-flex justify-content-between align-items-center"
                                >
                                  <Link
                                    type="button"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    onClick={() => handleDeletePayment(index)}
                                  >
                                    <img
                                      src={Closed}
                                      alt="img"
                                      style={{
                                        marginRight: "0.5rem",
                                        width: "0.9rem",
                                        height: "0.9rem",
                                      }}
                                    />
                                  </Link>
                                  <span className="key">
                                    <i className="icon ion-android-cancel"></i>

                                    {/* for the Insert time */}
                                    {paymentTypeMap[payment.PaymentId]}

                                    {/* // for the Update Time */}

                                    {paymentTypeMap[payment.ID]}
                                  </span>
                                  <span className="value ms-auto">
                                    {Number(payment.PaymentAmount).toFixed(2)}
                                  </span>
                                </li>
                              )
                          )}
                        </ul>
                      )}
                      {(selectedReceiveDropdown == 1 ||
                        selectedReceiveDropdown == 2 ||
                        selectedReceiveDropdown == 3 ||
                        selectedReceiveDropdown == 4 ||
                        selectedReceiveDropdown == 5) && (
                        <div>
                          <div className="row mt-2 border-bottom">
                            <div className="col-md-6 mt-2">
                              <label className="form-label">
                                Payment Curreny:
                              </label>
                            </div>
                            <div className="col-md-6 mb-2">
                              <select
                                className="form-select form-select-sm"
                                value={paymentCurrency}
                                onChange={(event) =>
                                  setPaymentCurrency(event.target.value)
                                }
                              >
                                <option value="USD">USD</option>
                                <option value="1">1</option>
                              </select>
                            </div>
                          </div>
                          {/* <div className="row mt-2 border-bottom">
                            <label className="form-label">
                              Add Coupon Codes
                            </label>
                            <div className="input-group mb-2">
                              <span className="input-group-text">
                                <i className="fa fa-tag"></i>
                              </span>

                              <input
                                className="form-control"
                                id="CouponCode"
                                name="CouponCode"
                                onChange={handleChangeCupon}
                                value={couponCode}
                              />
                            </div>
                          </div> */}
                        </div>
                      )}

                      <div className="row mt-2 border-bottom">
                        {selectedReceiveDropdown == 1 ||
                        selectedReceiveDropdown == 2 ||
                        selectedReceiveDropdown == 3 ||
                        selectedReceiveDropdown == 4 ||
                        selectedReceiveDropdown == 5 ||
                        selectedReceiveDropdown == 6 ||
                        selectedReceiveDropdown == 7 ? (
                          <div>
                            <div className="d-flex justify-content-center">
                              <div className="col-md-12 mb-2">
                                {(selectedReceiveDropdown == 7 &&
                                  restirctedit == 1) ||
                                (selectedReceiveDropdown == 2 &&
                                  restirctedit == 1) ? (
                                  ""
                                ) : (
                                  <button
                                    className="btn btn-outline-primary w-100"
                                    data-bs-target="#SuspendedModal"
                                    data-bs-toggle="modal"
                                    // onClick={() => {
                                    //   // handleSuspendedPopup();
                                    //   handleCompleteSale("suspend");
                                    // }}
                                    // onClick={handleSuspend}
                                  >
                                    {selectedReceiveDropdown == 1 && (
                                      <div className="d-inline-flex align-items-center">
                                        <i class="fas fa-solid fa-pause me-1"></i>
                                        Generate Purchase Order
                                      </div>
                                    )}
                                    {selectedReceiveDropdown == 2 && (
                                      <div className="d-inline-flex align-items-center">
                                        <i class="fas fa-solid fa-pause me-1"></i>
                                        Complete Receiving
                                      </div>
                                    )}
                                    {selectedReceiveDropdown == 3 && (
                                      <div className="d-inline-flex align-items-center">
                                        <i class="fas fa-solid fa-pause me-1"></i>
                                        Complete Return
                                      </div>
                                    )}
                                    {selectedReceiveDropdown == 4 && (
                                      <div
                                        className="d-inline-flex align-items-center"
                                        // onClick={() => showLocationError()}
                                      >
                                        <i class="fas fa-solid fa-pause me-1"></i>
                                        Complete Transfer
                                      </div>
                                    )}
                                    {(selectedReceiveDropdown == 5 ||
                                      selectedReceiveDropdown == 6 ||
                                      selectedReceiveDropdown == 7) && (
                                      <div className="d-inline-flex align-items-center">
                                        <i class="fas fa-solid fa-pause me-1"></i>
                                        Save
                                      </div>
                                    )}
                                  </button>
                                )}

                                {selectedReceiveDropdown == 4 &&
                                  !showTranser && (
                                    <div style={{ textAlign: "center" }}>
                                      <h3>OR</h3>
                                    </div>
                                  )}
                                {selectedReceiveDropdown == 4 &&
                                  !showTranser && (
                                    <div className="col-md-12 mb-2">
                                      <button
                                        className="btn btn-outline-primary w-100"
                                        // data-bs-target="#SuspendedModal"
                                        // data-bs-toggle="modal"
                                        type="button"
                                        onClick={handleIsComplete}
                                      >
                                        Send Transfer Request
                                      </button>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <label className="form-label">Add Payment</label>
                            <div className="mb-3">
                              {paymentTypeDropdown &&
                                paymentTypeDropdown.map((option, index) => (
                                  <button
                                    key={index}
                                    type="button"
                                    // className={`btn btn-outline-primary me-1 mb-1 ${selectedPaymentId  === option.ID ? 'active btn-primary' : ''}`}
                                    className={`btn btn-outline-primary me-1 mb-1 ${
                                      selectedPayment &&
                                      selectedPayment.id === option.ID
                                        ? "active btn-primary"
                                        : ""
                                    }`}
                                    // className={`btn btn-outline-primary me-1 mb-1 ${selectedPayment === option.ID ? 'active btn-primary' : ''}`}
                                    onClick={() =>
                                      handlePayment(
                                        option.Paymenttypename,
                                        option.ID,
                                        option.Paymenttypename
                                      )
                                    }
                                  >
                                    {option.Paymenttypename}
                                  </button>
                                ))}

                              <div className="input-group mt-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="0.00"
                                  value={amountToSubtract}
                                  onChange={handleAmountChange}
                                />
                                {dueAmount === parseFloat(amountToSubtract) ? (
                                  <span className="input-group-append">
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      data-bs-target="#CompleteModal"
                                      data-bs-toggle="modal"
                                      // onClick={() => {
                                      //   handleCompleteSale("complete");
                                      //   handleSubmit();
                                      // }}
                                    >
                                      Complete Receiving
                                    </button>
                                  </span>
                                ) : (
                                  <span className="input-group-append">
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={() => {
                                        handleCompleteSale("complete");
                                      }}
                                    >
                                      Add Payment
                                    </button>
                                  </span>
                                )}
                              </div>

                              {/* <div className="input-group mt-2">
                     <input
                       type="text"
                       className="form-control"
                       placeholder="0.00"
                       value={amountToSubtract}
                       onChange={handleAmountChange}
                     />
                     <span className="input-group-append">
                       <button
                         type="button"
                         className="btn btn-primary"
                         onClick={() => {
                           isAddPaymentEnabled ? handleSubmit() : handleCompleteSale();
                         }}
                         // disabled={!isAddPaymentEnabled}
                       >
                         {isAddPaymentEnabled ? "Add Payment" : "Complete Sale"}
                       </button>
                     </span>
                   </div> */}
                            </div>
                          </div>
                        )}
                        {/* Custom Field Binding */}

                        {customFields.map((data, index) => (
                          <>
                            <div className="row mt-2">
                              <label
                                className="col-form-label col-md-4 form-label  mb-2"
                                key={index}
                              >
                                {data.Name}
                              </label>
                              <div className="col-md-8">
                                {data.TypeName === "Text" ? (
                                  <input
                                    key={index}
                                    type="text"
                                    className="form-control"
                                    onChange={(event) => {
                                      // handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                    id={data.TypeName}
                                    name={data.Id}
                                  />
                                ) : data.TypeName === "E-Mail" ? (
                                  <input
                                    key={index}
                                    type="email"
                                    className="form-control"
                                    onChange={(event) => {
                                      // handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                    id={data.TypeName}
                                    name={data.Id}
                                  />
                                ) : data.TypeName === "Dropdown" ? (
                                  <>
                                    <Select
                                      key={index}
                                      id={data.TypeName}
                                      name={data.Id}
                                      backspaceRemovesValue={false}
                                      controlShouldRenderValue={true}
                                      hideSelectedOptions={true}
                                      isClearable={true}
                                      onChange={(event) => {
                                        handleCustomFieldsValues(
                                          event,
                                          data.TypeName,
                                          data.Id
                                        );
                                        setSelectedCustomField(event, index);
                                      }}
                                      options={data.Optionvalue.split(",").map(
                                        (option) => ({
                                          label: option,
                                          value: option,
                                          selectedValue: data.Name,
                                          selected: option === data.Id,
                                        })
                                      )}
                                      placeholder="Select"
                                      styles={selectStyles}
                                      // defaultValue={
                                      //   [data.Id] !== null && [data.Id] !== ""
                                      //     ? {
                                      //         label: [data.Id],
                                      //         value: [data.Id],
                                      //       }
                                      //     : ""
                                      // }
                                    />
                                  </>
                                ) : data.TypeName === "Checkbox" ? (
                                  <input
                                    key={index}
                                    className="form-check-input form-control"
                                    // style={{
                                    //   width: "1.5em",
                                    //   height: "1.5em",
                                    // }}
                                    type="checkbox"
                                    id={data.TypeName}
                                    name={data.Id}
                                    onChange={(event) => {
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                      handleChange(event);
                                    }}
                                    onInput={handleSelectCustomCheckBox}
                                  />
                                ) : data.TypeName === "Website" ? (
                                  <input
                                    key={index}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={(event) => {
                                      handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                    id={data.TypeName}
                                    name={data.Id}
                                  />
                                ) : data.TypeName === "PhoneNumber" ? (
                                  <input
                                    key={index}
                                    type="number"
                                    className="form-control form-control-sm"
                                    id={data.TypeName}
                                    name={data.Id}
                                    onChange={(event) => {
                                      handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                  />
                                ) : data.TypeName === "Date" ? (
                                  <input
                                    key={index}
                                    className="form-control form-control-sm"
                                    type="date"
                                    id={data.TypeName}
                                    name={data.Id}
                                    onChange={(event) => {
                                      handleChange(event);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                  />
                                ) : data.TypeName === "Image" ? (
                                  <>
                                    {/* <button onClick={()=> (console.log("selectedCustomImage",selectedCustomImage))}>Check</button> */}
                                    <div className="row">
                                      <FileInput
                                        type="file"
                                        key={index}
                                        className="form-control form-control-sm"
                                        id={data.TypeName}
                                        name={data.Id}
                                        value={selectedCustomImage}
                                        accept="image/*"
                                        handleChange={(event) => {
                                          _handleFileChange(event, index);
                                          handleCustomFieldsValues(
                                            event,
                                            data.TypeName,
                                            data.Name
                                          );
                                        }}
                                      />
                                    </div>
                                    <img
                                      src={`${
                                        formValues[data.Id]
                                          ? formValues[data.Id]
                                          : selectedCustomImage
                                      }`}
                                      className="ImagePreviewSize mt-3 mb-3"
                                    />

                                    {/* <div className="row">
                                      <div className="mt-2">
                                        <div
                                          className={`${
                                            [data.Id]
                                              ? ""
                                              : selectedCustomImage
                                              ? ""
                                              : "d-none"
                                          } form-group row`}
                                        >
                                          <label className="col-form-label col-md-2 form-label"></label>
                                          <div>
                                            <img
                                              src={`${
                                                [data.Id]
                                                  ? [data.Id]
                                                  : selectedCustomImage
                                              }`}
                                              alt="Category Image"
                                              // onClick={()=> (console.log("selectedCustomImage",data.Id))}
                                              className="ImagePreviewSize"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div> */}
                                  </>
                                ) : data.TypeName === "File" ? (
                                  <FileInput
                                    type="file"
                                    key={index}
                                    className="form-control form-control-sm"
                                    id={data.TypeName}
                                    name={data.Id}
                                    value={selectedCustomFile}
                                    handleChange={(event) => {
                                      // _handleFileChange(event, index);
                                      handleCustomFieldsValues(
                                        event,
                                        data.TypeName,
                                        data.Name
                                      );
                                    }}
                                  />
                                ) : null}
                              </div>
                            </div>
                          </>
                        ))}

                        {/* <div className="form-group">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="ChangeReceivingDate"
                              // onChange={handleCheckboxChange}
                            />
                            <label className="form-check-label">
                              Change receiving date
                            </label>
                          </div>
                        </div> */}
                        {/* {showDateInput && (
                          <div className="form-group">
                            <input
                              className="form-control"
                              type="date"
                              id="receivingDate"
                              name="receivingDate"
                            />
                          </div>
                        )} */}
                      </div>

                      <div className="form-group mt-2">
                        <textarea
                          className="form-control"
                          id="exampleTextarea"
                          name="exampleTextarea"
                          rows="3"
                          placeholder="Comments"
                          value={comment} // Set the value to the comment state variable
                          onChange={handleChangeComment}
                          // onChange={handleChangeComments}
                        ></textarea>
                      </div>
                      {/* <div className="form-group">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="showCommentsOnReceipt"
                          />
                          <label className="form-check-label">
                            Show comments on receipt
                          </label>
                        </div>
                      </div> */}
                    </div>
                  ) : null}
                  {/* This Button is only for the Store Account */}
                  {selectedReceiveDropdown == 6 && statenew.length === 0 && (
                    <button
                      className="btn btn-outline-primary ms-1 mb-2 w-100"
                      // data-bs-target="#SuspendedModal"
                      data-bs-target={selectedOption ? "#SuspendedModal" : ""}
                      onClick={(e) =>
                        selectedOption
                          ? ""
                          : toastError("Please select a supplier")
                      }
                      data-bs-toggle="modal"
                    >
                      <div className="d-inline-flex align-items-center">
                        <i class="fas fa-solid fa-pause me-1"></i>
                        Save
                      </div>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal ${modal ? "d-block" : ""}`}
        tabIndex="-1"
        style={{ background: "rgba(0,0,0,0.2)" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirmation</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal(false)}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <h6>
                    Payment transaction has been intiated, so you cant change
                    the type.
                  </h6>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setModal(false)}
              >
                Ok
              </button>
              {/* <button
                type="button"
                className="btn btn-secondary"
                // onClick={handleCancelDelete}
              >
                Cancel
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <CompleteSaleModal
        handleCompleteSale={handleCompleteSale}
        handleSubmit={handleSubmit}
        // selectedReceiveDropdown={selectedReceiveDropdown}
        disabled={selectedOption == null ? true : false}
      />
      <FilterModal callback={callbackItemGrid} runApi={runApi} />
      <CancelConfirmation handleCancelPopup={handleCancelPopup} />
      <SuspendedConfirmation handleSuspend={handleSuspend} type="Receiving" />

      {/* temp data comment for testing
      <ItemsDetailsModal ItemsDetails={itemsDetailsData} /> */}
      <ItemsDetailsModal id={itemsDetailsData ? itemsDetailsData.ItemId : 0} />
      {/* <LookupReceiptModal /> */}
    </>
  );
};

// Item SearchableDropdown
const SearchableDropdown = ({
  SupplierID,
  callback,
  disabled,
  selectedReceiveDropdown,
  readonly,
}) => {
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tableData, setTableData] = useState([]);

  //For Toaster
  const [show, setShow] = useState(false);

  useEffect(() => {
    //  fetchData();

    const timer = setTimeout(() => {
      if (inputValue) {
        // Make your API call here
        fetchData();
      }
    }, 500); // Adjust the delay according to your needs (in milliseconds)

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue, selectedReceiveDropdown]);

  // Fetch data from an API
  const fetchData = async () => {
    if (inputValue != "") {
      setSuggestions([]);
      let isReceiving = 1;
      if (selectedReceiveDropdown == 1) {
        isReceiving = 0;
      }

      await axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/searchforaccount?searchparam=${inputValue}&iscategory=${selectedReceiveDropdown}&supplierid=${
            SupplierID > 0 ? SupplierID : 0
          }&locationid=${location}&customerid=0`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          //console.log("ressssspsosossns", response.data.ResponseData)
          if (response.data.ResponseData.length > 0) {
            const data = response.data.ResponseData;
            if (data[0].ItemId > 0) {
              setSuggestions(data);
            }
          }
        })
        .catch((error) => {});
    } else {
      setSuggestions([]);
    }
  };

  //console.log(suggestions, "suggestions")

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const handleToast = () => {
    if (readonly === true) {
      toastError("Please Select a Supplier First");
    }
  };

  const handleInputClick = (
    pItemId,
    pItemName,
    pVariationName,
    pCostPrice,
    pUnitPrice,
    pItemQuantity,
    pDescription,
    pVariationId,
    pAttributeId,
    pModule,
    pCategoryID,
    pCategoryName,
    pItemnumber,
    pAllowaltdescription,
    pIsItemserialnumber,
    pVariationQuantity
    // pItemKitId
  ) => {
    if (pModule == "ItemKit") {
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/itemkitsitemslisting?itemkitid=${pItemId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;
            setSuggestions(data, () => {
              console.log("Suggestions", suggestions);
            });

            let tablesDatas = data.map((item) => ({
              ReceivingItemID: 0,
              ItemId: item.ItemId,
              ReceivingId: 0,
              CostPrice: item.CostPrice,
              UnitPrice: item.UnitPrice,
              ItemName: item.ItemName,
              VariationName: item.VariationName,
              itemquantity: selectedReceiveDropdown === 1 ? 0 : 1,
              ItemCurrentQuantity: item.VariationQuantity, // item.Itemquantity,
              itemdiscount: 0,
              Description: item.Description,
              VariationId: item.VariationId,
              AttributeId: item.AttributeId,
              Module: item.Module,
              Itemkitid: item.Itemkitid,
              CategoryID: item.CategoryID,
              Total: item.CostPrice,
              CategoryName: item.CategoryName,
              Itemnumber: item.Itemnumber,
              Allowaltdescription: item.Allowaltdescription,
              IsItemserialnumber: item.IsItemserialnumber,
            }));

            setTableData([tablesDatas[0]]); // modify this line
            setSuggestions([]);
          }
        })
        .catch((error) => {});
    } else {
      const selectedOption = {
        ReceivingItemID: 0,
        ItemId: pItemId,
        ReceivingId: 0,
        CostPrice: selectedReceiveDropdown === 1 ? 0 : pCostPrice,
        UnitPrice: pUnitPrice,
        ItemName: pItemName,
        VariationName: pVariationName,
        itemquantity: 1,
        ItemCurrentQuantity: pVariationQuantity, // pItemQuantity,
        itemdiscount: 0,
        Description: pDescription,
        VariationId: pVariationId,
        AttributeId: pAttributeId,
        Module: pModule,
        Itemkitid: 0,
        Total: pCostPrice,
        CategoryID: pCategoryID,
        CategoryName: pCategoryName,
        Itemnumber: pItemnumber,
        Allowaltdescription: pAllowaltdescription,
        IsItemserialnumber: pIsItemserialnumber,
      };

      setSuggestions([selectedOption]);
      setTableData([selectedOption]);
    }

    setInputValue("");
    setSuggestions([]);
  };

  useEffect(() => {
    const locationItemData = tableData.filter((locationItem) => {
      return locationItem.ItemId !== "";
    });

    callback(locationItemData);
  }, [tableData]);

  return (
    <div className="">
      <form>
        <div className="">
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <Link to="/manage-items">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </Link>
            </span>

            <input
              type="text"
              className="form-control form-control-sm"
              placeholder={
                selectedReceiveDropdown === 1
                  ? "Select category"
                  : "Type item name or scan barcode"
              }
              value={inputValue}
              onChange={handleInputChange}
              onClick={handleToast}
              disabled={disabled}
              readOnly={readonly}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div className="dropdown">
            <ul
              className="dropdown-menu w-100 show"
              style={{ "max-height": "500px", overflow: "auto" }}
            >
              {suggestions.map((item) => (
                <li
                  className="border-bottom"
                  key={item.ItemId}
                  onClick={() =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.VariationName,
                      item.CostPrice,
                      item.UnitPrice,
                      item.Itemquantity,
                      item.Description,
                      item.VariationId,
                      item.AttributeId,
                      item.Module,
                      item.CategoryID,
                      item.CategoryName,
                      item.Itemnumber,
                      item.Allowaltdescription,
                      item.IsItemserialnumber,
                      item.VariationQuantity
                      // item.ItemKitId
                    )
                  }
                >
                  <Link
                    key={item.ItemId}
                    href="#"
                    className="dropdown-item"
                    data-name={item.ItemName?.toLowerCase()}
                  >
                    <img
                      src={item.ImageName}
                      onError={(e) => {
                        e.currentTarget.src =
                          "https://th.bing.com/th/id/OIP.ADcGkW6WTfq2zu8yoY8vlgHaHa?w=197&h=197&c=7&r=0&o=5&pid=1.7";
                      }}
                      alt={item.ItemName}
                      className="img-thumbnail rounded-circle m-2"
                      width="55"
                      height="55"
                    />

                    <div className="customer-info">
                      <strong className="name word-break-data">
                        {item.ItemName}{" "}
                        {item.VariationName ? `(${item.VariationName})` : ""}
                        <Badge
                          className="ml-auto"
                          variant="primary"
                          style={{ position: "absolute", right: "5px" }}
                        >
                          {item.Module}
                        </Badge>
                      </strong>
                      {item.Module === "Accounts" ? (
                        <>
                          <div>Account Type: {item.AccountTypeName}</div>
                          <div>{item.AccountDeatilsTypeName}</div>
                        </>
                      ) : (
                        <>
                          <div>
                            {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)}{" "}
                            | Promo Price:{" "}
                            {parseFloat(item.PromoPrice).toFixed(2)}| Unit
                            Price: {parseFloat(item.UnitPrice).toFixed(2)} */}
                            {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)} | Qty: {parseInt(item.Itemquantity)} */}
                            Cost Price: {parseFloat(item.CostPrice).toFixed(2)}{" "}
                            | Qty: {parseInt(item.VariationQuantity)}
                          </div>
                          <div>Categories: {item.CategoryName}</div>
                        </>
                      )}

                      {/* Add any other customer details here */}
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </form>
    </div>
  );
};

export default ManageReceiving;
